// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {
    // General
    yes: "Ja",
    no: "Nein",
    cancel: "Abbrechen",
    showingRows: "Gefiltert {{shown}} / {{total}}",
    accept: "Annehmen",
    close: "Schließen",
    caution: "Achtung",
    exit: "Beenden",
    save: "Speichern",
    actionsForSelection: "Aktionen für Auswahl",

    processStatus:
    {
      INITIALIZED: "Initialisiert",
      UPLOADED: "Hochgeladen",
      STARTED: "Wird berechnet",
      PROCESSED: "Teilschritt berechnet",
      FAILED: "Kann nicht berechnet werden",
      DISABLED: "Ausgeschaltet",
      FINISHED: "Fertig",
      PAUSED: "Angehalten",
      TRIGGERED: "Wird berechnet",
      DELETED: "Gelöscht",
      DELETING: "Wird gelöscht",
      PROBLEM: "Wird untersucht",
      statusMapping: "Für weitere Informationen zum Prozessstatus wenden Sie sich bitte an die Dokumentation.",
      description: {
        INITIALIZED: "Alle Daten für die Prozessierung werden vorbereitet",
        UPLOADED: "Die Daten sind hochgeladen und die Prozessierung wird gestartet",
        STARTED: "Die Prozessierung läuft. Diese kann je nach Datenmenge und Systemauslastung mehrere Stunden oder Tage dauern. Wenn die Auslastung gering ist und die Prozessierung länger als erwartet dauert, wenden Sie sich bitte an den Support.",
        PROCESSED: "Die Daten wurden prozessiert und die Metadaten werden vorbereitet.",
        FAILED: "Der Prozess kann nicht berechnet werden. Es ist ein Fehler aufgetreten, den wir nicht lösen könnnen. Das kann unter anderem an den hochgeladenen Daten liegen.",
        DISABLED: "Prozess wurde von einem Administrator deaktiviert. Prozessdaten stehen nicht in den Viewern zur Verfügung.", // What user can do?
        FINISHED: "Die Prozessierung ist erfolgreich durchgelaufen und die Daten sind in den dazugehörigen Viewern sichtbar. Unter Prozessberechtigung können die Daten für Standardnutzer freigeschaltet werden.",
        PAUSED: "Prozess muss manuell fortgeführt werden.",
        TRIGGERED: "Die Prozessierung wurde ausgelöst.",
        DELETED: "Der Prozess und die zugehörigen Daten wurden gelöscht.",
        DELETING: "Der Prozess und die dazugehörigen Daten sind gelöscht.",
        PROBLEM: "Es ist ein Problem aufgetreten und wir prüfen den Prozess. Es kann dauern, bis wir das Problem lösen können abhängig von der Schwere des Problems. Wenn das Problem gelöst wird, wird der Status auf `Wird berechnet` aktualisiert, andernfalls auf `Kann nicht berechnet werden`.",
      },
    },
    systemHealth: {
      title: "Uploader Systemzustand",
      summaryTitle: "Systemauslastung",
      LOW: "Geringe Auslastung",
      MEDIUM: "Mittlere Auslastung",
      HIGH: "Hohe Auslastung",
      VERY_HIGH: "Sehr hohe Auslastung",
      description: {
        LOW: "Es werden derzeit wenige Prozesse verarbeitet, und Ihre Daten können ohne lange Wartezeit berechnet werden.",
        MEDIUM: "Es werden derzeit viele Prozesse verarbeitet, und es kann einige Zeit dauern, bis Ihre Daten verarbeitet sind.",
        HIGH: "Es werden derzeit sehr viele Prozesse verarbeitet, und es kann eine Weile dauern, bis Ihre Daten verarbeitet sind.",
        VERY_HIGH: "Es werden derzeit sehr viele Prozesse verarbeitet, und es kann lange dauern, bis Ihre Daten verarbeitet sind.",
      },
      loading: "Uploader-Status wird geladen...",
      error: "Uploader-Status konnte nicht geladen werden",
      lastUpdated: "Zuletzt aktualisiert",
    },
    // User Access
    ua: {
      loading: "Laden...",
      project_not_loaded: "Projekt konnte nicht geladen werden",
      access_denied: "Zugriff verweigert",
      user_access: "Benutzerfreigabe",
      user_name: "Benutzername",
      email: "E-Mail",
      roles: "Rollen",
      email_address: "E-Mail-Adresse",
      add_user: "Benutzer hinzufügen",
      import_user: "Benutzer aus Datei importieren",
      select_none: "Keinen\nauswählen",
      select_all: "Alle\nauswählen",
      remove_all: "Alle\nentfernen",
      remove_selected: "Ausgewählte\nentfernen",
      export_all: "Alle\nexportieren",
      export_selected: "Ausgewählte\nexportieren",
      copy_user_id: "Benutzer-ID kopieren",
      remove_user: "Benutzer entfernen",
      copy_id: "Benutzer-ID kopieren",
      id_copied: "Benutzer-ID kopiert",
      process_access: "Prozessfreigabe",
      process_filter: "Prozessfilter",
      remove_process_filter: "Prozessfilter entfernen",
      sections_and_processes: "Abschnitte und fertige Prozesse",
      external: "Extern",
      internal: "Intern",
      collapse_expand_processes: "Prozesse dieses Abschnitts {{collapse}}",
      collapse: "einklappen",
      expand: "ausklappen",
      alerts: {
        wrong_filetype: "Die Datei '{{file}}' kann nicht verarbeitet werden, da sie keine Textdatei ist.",
        user_not_added: "Die folgenden Benutzer konnten nicht hinzugefügt werden",
        user_in_project: "Benutzer ist bereits in diesem Projekt",
        user_added: "Die folgenden Benutzer wurden erfolgreich hinzugefügt",
        user_not_removed: "Die folgenden Benutzer konnten nicht entfernt werden",
        remove_all_users: "Möchten Sie wirklich alle ausgewählten Nutzer ({{count}}) entfernen?",
        remove_selected_users: "Möchten Sie wirklich alle ausgewählten Benutzer entfernen?",
        external_not_switched: "Die Freigabe für externe Mitarbeiter konnte nicht geändert werden",
        internal_not_switched: "Die Freigabe für interne Mitarbeiter konnte nicht geändert werden",
        process_not_switched: "Die Prozessfreigabe konnte nicht geändert werden",
      },
    },

    // Viewer
    v: {
      loading: "Laden...",
      too_many_containers: "Es können maximal drei Container geöffnet werden. " +
        "Bitte vor dem Fortfahren einen Container schließen.",
      multiple_3d: "Mehrere 3D-Container",
      multiple_3d_text: "Sie sind dabei, mehr als einen 3D-Container zu öffnen. " +
        "Dies kann zur Folge haben, dass Punktwolken langsamer laden. " +
        "Es empfiehlt sich deshalb, die maximale Größe der Punktwolken zu begrenzen. " +
        "Soll die maximale Punktwolkengröße in allen 3D-Containern auf 250.000 Punkte begrenzt werden? " +
        "Sie können die maximale Punktwolkengröße auch jederzeit in den Einstellungen im Punktwolkenmenü ändern.",
      add_panorama: "Sie haben mehrere 3D-Container geöffnet. " +
        "In welchem soll das Panorama-Bild angezeigt werden?",
      multiple_panoramas: "Mehrere Panorama-Bilder gefunden",
      multiple_panoramas_text: "An dieser Stelle befinden sich Panorama-Bilder aus verschiedenen Prozessen. " +
        "Das Panorama-Bild welches Prozesses möchten Sie anzeigen?",
      other_process: "Panorama-Bild aus anderem Prozess",
      other_process_text: "Das ausgewählte Panorama-Bild gehört zu einem anderen Prozess als das aktuell angezeigte Bild. " +
        "Möchten Sie fortfahren?",
      none: "Keinem / Abbrechen",
      close: "Schließen",
      process_overlay_next_page: "{{count}} ältere Prozesse...",
      process_overlay_prev_page: "{{count}} neuere Prozesse...",
      projectWithoutProcess: "Dieses Projekt besitzt keine Prozesse oder ist nicht verfügbar.",
      noImages: "Hier sind keine Bilder vorhanden oder diese wurden vor 2023 prozessiert.",
      displayProfile: "Profil anzeigen",
      errorProfileAdding: "Das Profil konnte zu keinem der aktuellen 3D-Viewer hinzugefügt werden, da mindestens ein Punkt nicht in einer aktiven Punktwolke liegt.",
      errorProfileAddingNew: "Das Profil konnte nicht zu einem neuen 3D-Viewer hinzugefügt werden, da mindestens ein Punkt nicht in einer Punktwolke liegt.",
      noActiveThreeDViewer: "Damit ein Profil angezeigt werden kann, muss es in einem 3D-Viewer aktiv sein. Aktuell sind zu viele Viewer geöffnet, um einen neuen 3D-Viewer hinzuzufügen.",
      invalidContainer: "Ungültiger Container zum Entfernen",
      automaticLoadingProcesses: "Das automatische Laden der Prozesse richtet sich nach der linken Karte",
      automaticLoading: "Für das automatische Laden ist eine Karte notwendig.",
      measurementAlreadyActiveHeader: "Messung aktiv",
      measurementAlreadyActive: "Es ist bereits eine Messung aktiv. Soll diese beendet werden und eine neue gestartet werden?",
      editingAlreadyActiveHeader: "Bearbeitung aktiv",
      editingAlreadyActive: "Es wird bereits eine Messung bearbeitet. Möchten Sie den Bearbeitungsmodus beenden und eine neue Messung starten?",
      addProfileToCurrent: "Damit ein Profil angezeigt werden kann, muss es in einem 3D-Viewer aktiv sein. Soll dieses Profil zu einem der aktuellen 3D-Viewer hinzugefügt werden?",
      addProfileToNew: "Damit ein Profil angezeigt werden kann, muss es in einem 3D-Viewer aktiv sein. Soll ein neuer 3D-Viewer hinzugefügt werden? Hinweis: dies kann ein paar Sekunden dauern.",
      alert: "Das sollte nicht passieren.",
      max_active_geo_layers: "Es können maximal {{count}} GEO-/Objekt-Layer gleichzeitig aktiv sein.",
      gnd_profile_requires_layer: "Für ein Profil muss ein GND-Layer im 3D-Viewer sichtbar sein.",
      gnd_profile_no_visible_line: "Im aktuellen 3D-Ausschnitt ist keine auswählbare GND-Linie sichtbar.",
      gnd_profile_failed: "Das Profil konnte nicht erstellt werden.",
      axis_measurement_requires_km_layer: "Für diese Messung muss ein Kilometrierungs-Layer (GND) im 3D-Viewer sichtbar sein.",
      axis_measurement_requires_track_layer: "Für diese Messung muss ein Gleisachsen-Layer (GND) im 3D-Viewer sichtbar sein.",
      axis_measurement_no_visible_axis: "Im aktuellen 3D-Ausschnitt ist keine auswählbare Achse sichtbar.",
      axis_measurement_no_km_data: "Die ausgewählte Achse enthält keine Kilometrierungsangaben.",
      axis_measurement_km_data_problem: "Problem mit Gleisnetzdaten.",
      axis_measurement_failed: "Die Achsenmessung konnte nicht durchgeführt werden.",
      windows: {
        catalog: "Katalog",
        measurements: "Messungen",
        layer_menu: "Layermenü",
        gis_object: "GIS-Objekt",
      },
      axis_measurement_names: {
        KILOMETRIERUNG: "Kilometrierung",
        KILOMETRIERUNG_DISTANCE: "Km-Achse",
        GLEISACHSE_DISTANCE: "Gleisachse",
        GLEISACHSE_GAP: "Achsabstand",
      },
      measurement_details: {
        results: "Messergebnisse",
        resample_elevation: "Elevation aus Punktwolke übernehmen",
        total_length: "Gesamtlänge",
        projected_length: "Projizierte Länge",
        vertical_extent: "Vertikale Ausdehnung",
        line_details: "Details ({{segments}} Segmente, {{vertices}} Stützpunkte)",
        segments: "Segmente ({{count}})",
        segment: "Seg. {{n}}",
        slope: "Neigung",
        vertices: "Stützpunkte ({{count}})",
        add_point: "Punkt hinzufügen",
        area_2d: "Fläche (2D)",
        perimeter: "Umfang",
        polygon_details: "Details ({{edges}} Kanten)",
        edges: "Kanten ({{count}})",
        edge: "Kante {{n}}",
        fill: "Auftrag",
        cut: "Abtrag",
        total_volume: "Totales Volumen",
        height_difference: "Höhendifferenz (ΔZ)",
        horizontal_distance: "Horizontaler Abstand",
        distance_3d: "3D-Abstand",
        base_point: "P1 (Basis)",
        compare_point: "P2 (Vergleich)",
        volume_options: "Berechnungsoptionen (Volumen)",
        flatten: "Auf Ebene begradigen",
        plane_height: "Ebenenhöhe",
        undo_flatten: "Rückgängig (ursprüngliche Höhen wiederherstellen)",
        max_height: "maximale Höhendifferenz",
        max_height_hint: "Maximaler Abstand eines Punktes von der Referenzebene, um gezählt zu werden",
        name: "Name",
        description: "Beschreibung",
        type_point: "Punkt",
        type_line: "Linie",
        type_polygon: "Polygon",
        type_volume: "Volumen",
        type_height_difference: "Höhendifferenz",
        labels: "Maße",
        mirror: "In andere Ansicht spiegeln",
        finish_edit: "Bearbeitung abschließen",
        edit: "Bearbeiten",
        recalc_volume: "Volumen neu berechnen",
        open_profile: "Profil öffnen",
        zoom_to: "Hinzoomen",
      },
      axis_details: {
        km: "Kilometrierung",
        km_data: "Gleisnetzdaten",
        side: "Seite",
        distance_to_axis: "Abstand zur Achse",
        series: "Serie",
        role: "Art",
        calibration: "Kalibrierung",
        calibration_offset: "Kalibrierter Versatz",
        distance_along_axis: "Abstand entlang der Achse",
        distance_to_track_centre: "Abstand zur Gleismitte",
        distance_to_gnd_axis: "Abstand zur GND-Achse",
      },
      clip_reference_requires_axis_layer: "Für einen Schnitt entlang einer Achse muss ein GIS-Achsen-Layer (GND) im 3D-Viewer sichtbar sein.",
      clip_reference_no_visible_axis: "Im aktuellen 3D-Ausschnitt ist keine auswählbare Achse sichtbar.",
      max_active_geo_layers_short: "Max. {{count}}",
      too_many_panoramas: "X2BIM unterstützt derzeit kein gleichzeitiges Anzeigen von Panorama-Bildern in verschiedenen Containern.",
      panorama_currently_active: "Ein diesem Prozess zugehöriges Panorama-Bild wird gerade im 3D-Container angezeigt. " +
        "Bitte verlassen Sie zunächst den Panorama-Modus, bevor Sie diesen Prozess aus dem Container entfernen.",

      // Menubar
      mb: {
        ortho: "Orthos",
        plan: "Pläne",
        dgm: "DGMs",
        pointcloud: "Punktwolken",
        panorama: "360°",
        uav_lite: "Fotos",
        glb: "IFC",
        video: "Video",
        ki: "Geo/Objekte",
        annotation: "Annotationen",
        ortho_long: "Orthobilder",
        plan_long: "Pläne",
        dgm_long: "Digitale Geländemodelle",
        pointcloud_long: "Punktwolken",
        panorama_long: "Panoramas",
        glb_long: "IFC Modelle",
        video_long: "Streckenvideos",
        ki_long: "KI-Objekte",
        annotation_long: "Annotationen",
        ortho_help: "Das zuletzt hinzugefügte Orthobild wird oben auf der Karte angezeigt. " +
          'Beim Auswählen der Einstellung "Ressourcen automatisch nachladen" erfolgt das Hinzufügen der Daten chronologisch, mit dem aktuellsten Prozess oben.',
        plan_help: "Pläne werden von uns analog zu Orthobildern gekachelt und auf der Karte dargestellt. " +
          'Beim Auswählen der Einstellung "Ressourcen automatisch nachladen" erfolgt das Hinzufügen der Daten chronologisch, mit dem aktuellsten Prozess oben. ' +
          "Grundsätzlich liegen Pläne immer über gleichzeitig eingeblendeten Orthobildern und DGMs.",
        dgm_help: "Digitale Geländemodelle werden von uns analog zu Orthobildern gekachelt und in verringerter Auflösung auf der Karte dargestellt. " +
          'Beim Auswählen der Einstellung "Ressourcen automatisch nachladen" erfolgt das Hinzufügen der Daten chronologisch, mit dem aktuellsten Prozess oben. ' +
          "Grundsätzlich liegen DGMs immer über gleichzeitig eingeblendeten Orthobildern.",
        pointcloud_help: "Zur besseren Orientierung im 3D-Punktwolkenviewer sollte immer mindestens eine Punktwolke eingeblendet sein. " +
          'Die Kameraeinstellung "Earth-Modus" funktioniert nur auf Basis einer eingeblendeten Punktwolke',
        panorama_help: "Momentan ist der Upload von Panoramabildern für die Projekte Video2BIM und Multisensorplattform möglich. " +
          "Nach dem Auswählen eines Panoramas im 2D- oder 3D-Viewer erfolgt die Darstellung im 3D-Viewer, das Verlassen der Ansicht ist über die Schaltfläche unten im Viewer möglich. " +
          "Messen im Panoramabild ist nur auf Grundlage einer gleichzeitig angezeigten Punktwolke möglich.",
        glb_help: "Grundsätzlich liegen IFC immer über gleichzeitig eingeblendeten Punktwolken.",
        video_help: "Im 2D-Viewer erscheint eine rot gestrichelte Linie, die die Strecke abbildet, auf der das ausgewählte Video aufgenommen wurde. " +
          "Sobald auf die Linie geklickt wird, startet das Video in einem neuen Container.",
        ki_help: "Beim Upload in X2BIM kann die Erkennung von LST-Objekten aktiviert werden. " +
          "Wenn hier eine Objektklasse aktiviert wird, erscheinen die Objekte auf der Karte, wenn gleichzeitig das zugehörige Datum in ORTHOS aktiv ist.",
        annotation_help: "Annotationen können aus Distanzmessungen, Flächenmessungen und Markern erstellt werden. " +
          "Dafür müssen diese zunächst über die Werkzeugleiste unten angelegt werden.<hr />" +
          "Über das Messmenü ist dann die Erstellung der Annotation möglich. " +
          "Im Moment ist dies <b>nur möglich, wenn die Messung auf einem Orthobild angelegt</b> wurde. " +
          "Diese wird dann hier im Annotationsmenü als temporäre Annotation angezeigt.<hr />" +
          'Dauerhaft gespeichert wird diese mithilfe des "Speichern"-Buttons welcher in der ausgeklappten Annotation erscheint.',
        uav_lite_help: "UAV Lite ist ein neues, von X2BIM entwickeltes Format für die Darstellung von Fotos auf der Karte. ",
        search: "Suchfunktion",
        share: "Teilen",
        clear: "Viewer zurücksetzen",
        defaultSettings: "Standardeinstellungen",
        help: "Einführung/Hilfe",
        container: "Ansichtverwaltung",
        account: "Account",
        screenshot: "Bildschirmfoto",
        project_loading: "Projekt wird geladen...",
        cancel_loading: "Laden abbrechen",
        expand_settings: "Einstellungen ein/ausblenden",
        compare: "Vergleichen",
        close_compare: "Vergleichsfunktion schließen",
        no_openlayers: "Keine 2D-Karte/Container aktiv",
        too_many_openlayers: "Der Vergleichsmodus kann nur in einer 2D-Karte aktiv sein. Bitte gewünschte 2D-Karte wählen.",
        too_many_containers: "Aktuell ist mehr als ein Container geöffnet. Es empfielt sich für die Vergleichsfunktion alle anderen Container zu schließen.",
        remove_containers: "Andere Container schließen",
        keep_containers: "Andere Container behalten",
        cancel: "Abbrechen",
        no_process: "Kein aktiver Prozess",
        linkcopied: "Link kopiert",
        download_option: "Downloadoption wählen",
        no_settings_found: "Keine Einstellungen gefunden",
        enabled: "Aktiviert",
        default: "Standard",
        last_modified: "Zuletzt geändert",
        add_new_setting: "Neue Einstellung hinzufügen",
        edit_setting: "Einstellung bearbeiten",
        setting_name: "Einstellungsname",
        set_default: "Als Standard festlegen",
        set_enabled: "Einstellung aktivieren",
        save: "Speichern",
        cancel: "Abbrechen",
        format_not_available: "Das ausgewählte Format ist für diesen Prozess nicht verfügbar.",
      },

      //2D Container
      openLayers: {
        basePoint: "Basispunkt",
        noVideos: "Keine Videos für diesen Prozess vorhanden",
        volumesOnly: "Volumen können nur auf DGMs oder Orthobildern gemessen werden.",
        pointNoLongerOnProcess: "Der geänderte Punkt befindet sich nicht mehr auf einem DGM oder Orthobild",
        errorVolumeCalculation: "Fehler bei der Volumenberechnung",
        errorVolumeDifference: "Volumendifferenzen können nur auf DGMs oder Orthobildern gemessen werden. Auf beiden Seiten des Vergleichwerkzeugs müssen unterschiedliche DGMs oder Orthobilder aktiv sein",
        noProcess: "Kein Prozess gefunden.",
        left: "LINKS",
        right: "RECHTS",
        on_axis: "AUF ACHSE",
        fill: "Auftrag",
        cut: "Abtrag",
        height: "Höhendif."
      },

      //Potree Cotainer
      potree: {
        cancelTransmission: "Mindestens ein Punkt der Messung lässt sich nicht übertragen, da er nicht innerhalb der Punktwolke liegt. Die Übertragung wird abgebrochen.",
        threeDMeasurementNotPossible: "3D-Messungen sind auf Ihrem Gerät nicht möglich.",
        polygonsInThreeD: "Polygone aus Gleisnetzdaten können nur im 3D-Viewer angezeigt werden, wenn sich alle Punkte des Polygons innerhalb einer Punktwolke befinden.",
        removeProfile: "Damit ein Profil angezeigt werden kann, muss es in einem 3D-Viewer aktiv sein. Wenn Sie das Profil aus diesem 3D-Viewer entfernen, wird auch der aktuell geöffnete Profil-Viewer geschlossen. Möchten Sie fortfahren?"
      },

      // Dropdowns
      dd: {
        pin_dropdown: "Fenster anpinnen",
        show_info: "Informationen",
        show_settings: "Einstellungen",
        show_filter: "Filteroptionen",
        search: "Ressourcensuche",
        search_placeholder: "Datum | Titel | Beschreibung | Tags",
      },

      // Geo data (old base map) menu
      base: {
        basemap: "Basiskarte",
        grayscale: "Grautöne",
        terrain: "Topographie",
        satellite: "Satellit",
        hectometer: "Hektometerpunkte",
        ivl: "IVL Sektionen",
        openrailwaymap_infra: "OpenRailMap (Infrastruktur)",
        openrailwaymap_signal: "OpenRailMap (LST)",
        process_clusters: "Prozess-Cluster",
        ivl_plans_west: "IVL Pläne",
        pzb_magnet: "PZB-Magneten",
        acz: "ACZ",
        etc: "ETCS",
        schaltschrank: "Schaltschrank",
        mast: "Signale",
        active: "aktiv",
        inactive: "inaktiv",
        signals: "Signale",
        increasezoom: "Zoom erhöhen!",
        decreasezoom: "Zoom verringern!",
        nobasemapwarn: "Geodateneinstellungen sind nur bei vorhandener Karte verfügbar.",
        still_active_header: "Deaktivieren nicht möglich",
        still_active_content: "Die Geodaten sind noch in mindestens einem 3D-Container aktiv. " +
          "Um sie auf der Karte deaktivieren zu können, müssen sie erst in allen 3D-Containern deaktiviert werden. " +
          "Sollen die Geodaten aus allen 3D-Containern entfernt werden?",
        not_active_header: "Aktivieren nicht möglich",
        not_active_content: "Die Geodaten sind nicht auf der Karte aktiv. " +
          "Um sie in einem 3D-Container aktivieren zu können, müssen sie erst auf der Karte aktiviert werden. " +
          "Sollen die Geodaten auf der Karte aktiviert werden?",
        clearMapHeader: "Möchten Sie wirklich den Viewer zurücksetzen?",
        clearMapPopupMessage: "Dies wird alle ungespeicherten Fortschritte löschen und den Viewer neustarten. Zum Fortfahren Ja klicken.",
      },

      // Process menus (Ortho, Pläne, DGMs, Punktwolken)
      process: {
        toggle_single: "Einzel",
        toggle_time: "Zeitfenster",
        toggle_download: "Download",
        filter: "Filtern...",
        download: "Aktive Ressourcen herunterladen",
        deselect: "Auswahl aufheben",
        dgm: "DGM",
        dom: "DOM",
        geo_inspect: "GeoInspect",
        uploads_from: "Uploads ab {{date}}",
        feb_2023: "02/2023",
        images: "Bilder",
        remove: "{{geo_inspect}} entfernen",
        activate_all: "Alle aktivieren",
        activate_all_extent: "In Ausschnitt aktivieren",
        deactivate_all: "Alle deaktivieren",
        open_viewer: "{{viewer}} öffnen",
        viewer_2d: "2D-Karte",
        viewer_3d: "3D-Viewer",
        time_plans: "Für Pläne ist die Zeitfensterauswahl nicht verfügbar.",
        visible_processes: "Prozesse", //visible_processes: "Angezeigte Prozesse",
        timespan: "Zeitraum",
        days: "Tage",
        scanner: "Scanner",
        processes: "Prozesse",
        percent: "{{value}}%",
        top: "TOP",
        left: "Comp. links",
        right: "Comp. rechts",
        collapse: "Einzelne Ressourcen dieser Gruppe ausblenden",
        expand: "Einzelne Ressourcen dieser Gruppe anzeigen",
        details: "Ressourceninformationen loggen",
        copyUrl: "Punktwolken-URL in die Zwischenablage kopieren",
        color: "Punktewolke einfärben",
        color_all: "Alle aktiven Punktwolken dieser Gruppe einfärben",
        elevation: "Punktwolke nach Höhe einfärben",
        elevation_all: "Alle aktiven Punktwolken dieser Gruppe nach Höhe einfärben",
        settingAll: "Darstellungseigenschaften",
        resetAttributes: "Einfärbung zurücksetzen",
        inspect: "Inspect-Funktion für dieses Orthobild",
        inspect_all: "Inspect-Funktion für alle aktiven Orthobilder dieser Gruppe",
        external_viewer: "Ext. Viewer",
        tagAktiv: "nur aktivierte Tags anzeigen",
        link_types: "{{- types}} gemeinsam laden",
        ortho_pointcloud: "Ortho/Punktwolke",
        pointcloud_panorama: "Punktwolke/Panorama",
        pointcloud_classes: {
          0: "Nie klassifiziert",
          1: "Nicht zugewiesen",
          2: "Oberfläche",
          3: "Niedrige Vegetation",
          4: "Mittelhohe Vegetation",
          5: "Hohe Vegetation",
          6: "Gebäude",
          7: "Tiefpunkt",
          8: "Modellschlüsselpunkt",
          9: "Wasser",
          10: "Schienen",
          11: "Straßenbelag",
          12: "Reserviert",
          13: "Schutzdraht (Schild)",
          14: "Drahtleiter (Phase)",
          15: "Strommast",
          16: "Leitungsverbinder (Isolator)",
          17: "Brückenfahrbahn",
          18: "Hohes Rauschen",
          19: "Reserviert",
          20: "Reserviert",
          21: "Reserviert",
          22: "Reserviert",
          23: "Reserviert",
          24: "Reserviert",
          25: "Reserviert",
          26: "Reserviert",
          27: "Reserviert",
          28: "Reserviert",
          29: "Reserviert",
          30: "Reserviert",
          31: "Reserviert",
          32: "Reserviert",
          33: "Reserviert",
          34: "Reserviert",
          35: "Reserviert",
          36: "Reserviert",
          37: "Reserviert",
          38: "Reserviert",
          39: "Reserviert",
          40: "Reserviert",
          41: "Reserviert",
          42: "Reserviert",
          43: "Reserviert",
          44: "Reserviert",
          45: "Reserviert",
          46: "Reserviert",
          47: "Reserviert",
          48: "Reserviert",
          49: "Reserviert",
          50: "Reserviert",
          51: "Reserviert",
          52: "Reserviert",
          53: "Reserviert",
          54: "Reserviert",
          55: "Reserviert",
          56: "Reserviert",
          57: "Reserviert",
          58: "Reserviert",
          59: "Reserviert",
          60: "Reserviert",
          61: "Reserviert",
          62: "Reserviert",
          63: "Reserviert",
          64: "Benutzerdefiniert",
          65: "Benutzerdefiniert",
          66: "Benutzerdefiniert",
          67: "Benutzerdefiniert",
          68: "Benutzerdefiniert",
          69: "Benutzerdefiniert",
          70: "Benutzerdefiniert",
          71: "Benutzerdefiniert",
          72: "Benutzerdefiniert",
          73: "Benutzerdefiniert",
          74: "Benutzerdefiniert",
          75: "Benutzerdefiniert",
          76: "Benutzerdefiniert",
          77: "Benutzerdefiniert",
          78: "Benutzerdefiniert",
          79: "Benutzerdefiniert",
          80: "Benutzerdefiniert",
          81: "Benutzerdefiniert",
          82: "Benutzerdefiniert",
          83: "Benutzerdefiniert",
          84: "Benutzerdefiniert",
          85: "Benutzerdefiniert",
          86: "Benutzerdefiniert",
          87: "Benutzerdefiniert",
          88: "Benutzerdefiniert",
          89: "Benutzerdefiniert",
          90: "Benutzerdefiniert",
          91: "Benutzerdefiniert",
          92: "Benutzerdefiniert",
          93: "Benutzerdefiniert",
          94: "Benutzerdefiniert",
          95: "Benutzerdefiniert",
          96: "Benutzerdefiniert",
          97: "Benutzerdefiniert",
          98: "Benutzerdefiniert",
          99: "Benutzerdefiniert",
          100: "Benutzerdefiniert",
          101: "Benutzerdefiniert",
          102: "Benutzerdefiniert",
          103: "Benutzerdefiniert",
          104: "Benutzerdefiniert",
          105: "Benutzerdefiniert",
          106: "Benutzerdefiniert",
          107: "Benutzerdefiniert",
          108: "Benutzerdefiniert",
          109: "Benutzerdefiniert",
          110: "Benutzerdefiniert",
          111: "Benutzerdefiniert",
          112: "Benutzerdefiniert",
          113: "Benutzerdefiniert",
          114: "Benutzerdefiniert",
          115: "Benutzerdefiniert",
          116: "Benutzerdefiniert",
          117: "Benutzerdefiniert",
          118: "Benutzerdefiniert",
          119: "Benutzerdefiniert",
          120: "Benutzerdefiniert",
          121: "Benutzerdefiniert",
          122: "Benutzerdefiniert",
          123: "Benutzerdefiniert",
          124: "Benutzerdefiniert",
          125: "Benutzerdefiniert",
          126: "Benutzerdefiniert",
          127: "Benutzerdefiniert",
          128: "Benutzerdefiniert",
          129: "Benutzerdefiniert",
          130: "Benutzerdefiniert",
          131: "Benutzerdefiniert",
          132: "Benutzerdefiniert",
          133: "Benutzerdefiniert",
          134: "Benutzerdefiniert",
          135: "Benutzerdefiniert",
          136: "Benutzerdefiniert",
          137: "Benutzerdefiniert",
          138: "Benutzerdefiniert",
          139: "Benutzerdefiniert",
          140: "Benutzerdefiniert",
          141: "Benutzerdefiniert",
          142: "Benutzerdefiniert",
          143: "Benutzerdefiniert",
          144: "Benutzerdefiniert",
          145: "Benutzerdefiniert",
          146: "Benutzerdefiniert",
          147: "Benutzerdefiniert",
          148: "Benutzerdefiniert",
          149: "Benutzerdefiniert",
          150: "Benutzerdefiniert",
          151: "Benutzerdefiniert",
          152: "Benutzerdefiniert",
          153: "Benutzerdefiniert",
          154: "Benutzerdefiniert",
          155: "Benutzerdefiniert",
          156: "Benutzerdefiniert",
          157: "Benutzerdefiniert",
          158: "Benutzerdefiniert",
          159: "Benutzerdefiniert",
          160: "Benutzerdefiniert",
          161: "Benutzerdefiniert",
          162: "Benutzerdefiniert",
          163: "Benutzerdefiniert",
          164: "Benutzerdefiniert",
          165: "Benutzerdefiniert",
          166: "Benutzerdefiniert",
          167: "Benutzerdefiniert",
          168: "Benutzerdefiniert",
          169: "Benutzerdefiniert",
          170: "Benutzerdefiniert",
          171: "Benutzerdefiniert",
          172: "Benutzerdefiniert",
          173: "Benutzerdefiniert",
          174: "Benutzerdefiniert",
          175: "Benutzerdefiniert",
          176: "Benutzerdefiniert",
          177: "Benutzerdefiniert",
          178: "Benutzerdefiniert",
          179: "Benutzerdefiniert",
          180: "Benutzerdefiniert",
          181: "Benutzerdefiniert",
          182: "Benutzerdefiniert",
          183: "Benutzerdefiniert",
          184: "Benutzerdefiniert",
          185: "Benutzerdefiniert",
          186: "Benutzerdefiniert",
          187: "Benutzerdefiniert",
          188: "Benutzerdefiniert",
          189: "Benutzerdefiniert",
          190: "Benutzerdefiniert",
          191: "Benutzerdefiniert",
          192: "Benutzerdefiniert",
          193: "Benutzerdefiniert",
          194: "Benutzerdefiniert",
          195: "Benutzerdefiniert",
          196: "Benutzerdefiniert",
          197: "Benutzerdefiniert",
          198: "Benutzerdefiniert",
          199: "Benutzerdefiniert",
          200: "Benutzerdefiniert",
          201: "Benutzerdefiniert",
          202: "Benutzerdefiniert",
          203: "Benutzerdefiniert",
          204: "Benutzerdefiniert",
          205: "Benutzerdefiniert",
          206: "Benutzerdefiniert",
          207: "Benutzerdefiniert",
          208: "Benutzerdefiniert",
          209: "Benutzerdefiniert",
          210: "Benutzerdefiniert",
          211: "Benutzerdefiniert",
          212: "Benutzerdefiniert",
          213: "Benutzerdefiniert",
          214: "Benutzerdefiniert",
          215: "Benutzerdefiniert",
          216: "Benutzerdefiniert",
          217: "Benutzerdefiniert",
          218: "Benutzerdefiniert",
          219: "Benutzerdefiniert",
          220: "Benutzerdefiniert",
          221: "Benutzerdefiniert",
          222: "Benutzerdefiniert",
          223: "Benutzerdefiniert",
          224: "Benutzerdefiniert",
          225: "Benutzerdefiniert",
          226: "Benutzerdefiniert",
          227: "Benutzerdefiniert",
          228: "Benutzerdefiniert",
          229: "Benutzerdefiniert",
          230: "Benutzerdefiniert",
          231: "Benutzerdefiniert",
          232: "Benutzerdefiniert",
          233: "Benutzerdefiniert",
          234: "Benutzerdefiniert",
          235: "Benutzerdefiniert",
          236: "Benutzerdefiniert",
          237: "Benutzerdefiniert",
          238: "Benutzerdefiniert",
          239: "Benutzerdefiniert",
          240: "Benutzerdefiniert",
          241: "Benutzerdefiniert",
          242: "Benutzerdefiniert",
          243: "Benutzerdefiniert",
          244: "Benutzerdefiniert",
          245: "Benutzerdefiniert",
          246: "Benutzerdefiniert",
          247: "Benutzerdefiniert",
          248: "Benutzerdefiniert",
          249: "Benutzerdefiniert",
          250: "Benutzerdefiniert",
          251: "Benutzerdefiniert",
          252: "Benutzerdefiniert",
          253: "Benutzerdefiniert",
          254: "Benutzerdefiniert",
          255: "Benutzerdefiniert",
          DEFAULT: "default"
        },
        pointcloud_eyedom: "Schattierung",
        pointcloud_elevation: "Höhenskala",
        pointcloud_elevationRepeat: "Höhen",
        pointcloud_elevationMin: "Bezugshöhe",
        pointcloud_elevationInterval: "Intervall",
        pointcloud_elevationRange: "Höhenintervall",
        pointcloud_color: "Farbe",
        pointcloud_colorClass: "Farbe nach Klassifizierung",
        pointcloud_intensity: "Intensität",
        pointcloud_intensityGradient: "Intensität Gradient",
        pointcloud_intensityRange: "Intensitätsintervall",
        pointcloud_RGBAGamma: "Gamma",
        pointcloud_RGBABrightness: "Helligkeit",
        pointcloud_RGBAContrast: "Kontrast",
        pointcloud_intesityGradiantGamma: "Gamma",
        pointcloud_intesityGradiantBrightness: "Helligkeit",
        pointcloud_intesityGradiantContrast: "Kontrast",
        pointcloud_reset: "Zurücksetzen",
        filterText: "nach Zeit, Name oder Tag",
        timestart: "ab",
        timeend: "bis",
        includes: "enthält",
        showmodel: "Modell zeigen",
        showwireframe: "Wireframe zeigen",
        settings: "Einstellungen",
        autoload: "Ressourcen automatisch nachladen",
        process_clusters: "Prozess-Cluster anzeigen",
        sortby_date: "Datum",
        sortby_title: "Titel",
        sortby_description: "Beschreibung",
        alloff: "alle aus",
        transparency: "Transparenz",
        opacity: "Deckkraft",
        max_points: "Maximal {{count}} Punkte",
        point_size: "Punktgröße",
        small: "Klein",
        large: "Groß",
        point_budget: "Punktdichte",
        low: "Niedrig",
        high: "Hoch",
        filter_type: "Typ",
        filter_extent: "Kartenausschnitt",
        filter_extent_help: "Wenn angeschaltet, werden nur Ressourcen gezeigt, die im aktuellen Kartenausschnitt sichtbar sind",
        filter_date: "Datum",
        filter_tag: "Tag",
        filter_type_drone: "Multikopterbefliegung",
        filter_type_helicopter: "Helikopterbefliegung",
        filter_type_video: "Video2BIM",
        filter_type_train: "MSP-Befahrung",
        filter_type_cad: "Plan",
        filter_type_null: "Sonstige",
        open_calendar: "Kalenderauswahl öffnen",
        reset_filters: "Filtereinstellungen zurücksetzen",
        resources_filtered: "Filter: Es werden {{filtered}} von {{total}} Ressourcen angezeigt",
        no_resources_filtered: "Zu diesen Filtereinstellungen gibt es keine passenden Ressourcen",
        no_date: "Kein Datum",
        no_title: "Kein Titel",
        no_description: "Keine Beschreibung",
        resource_count: "{{count}} Ressourcen",
        new_3d: "Neuer 3D-Viewer",
        new_2d: "Neue 2D-Karte",
      },

      // KI menu
      ki: {
        ai_objects: "KI-Objekte",
        overview: "Übersicht",
        track_data: "Gleisnetzdaten",
        Detections: "KI-Objekte",
        Strecken: "Strecken",
        Objekte: "Andere GIS-Daten",
        wmsServices: "WMS-Dienste",
        WMS: "WMS-Dienste (Experimentell)",
      },

      // Annotations menu
      annot: {
        not_available: "Nicht verfügbar",
        archived: "ARCHIVIERT",
        viewer_2d: "2D-Karte",
        viewer_3d: "3D-Viewer",
        save: "Speichern",
        archive: "Archivieren",
        download: "Als JSON herunterladen",
        title: "Titel",
        flight: "Flugbezeichnung",
        dimension: "Maß",
        trade: "Gewerk",
        edit: "Bearbeiten",
        saved: "Gespeichert",
        unsaved: "Ungespeichert",
        created: "Erstellt",
        changed: "Zuletzt geändert",
        description: "Beschreibung",
        unsaved_tooltip: "ungespeichert ({{value}})",
        unsaved_name: "Ungespeicherte {{meastype}}annotation",
        header: "Annotation erzeugen",
        process_found: 'Prozess vom Typ "{{processtype}}" gefunden',
        no_process: "Es wurde kein zugehöriger Prozess gefunden.",
        with: "Auf Prozess verweisen",
        without: "Ohne Prozessverweis",
        create: "Neue Annotation",
        extend: "Annotation erweitern",
        save_first: "Annotation zuerst speichern",
        selected: "ausgewählt",
        create_button: "Annotation erstellen",
        extend_button: "Annotation(en) erweitern",
        meastypes: {
          distance: "Distanz",
          area: "Flächen",
          volume: "Volumen",
          volume_delta: "Volumendifferenz",
          marker: "Koordinatenmarker",
          angle: "Winkel",
          height: "Höhendifferenz",
          profile: "Profil",
          kilometrierung: "Kilometrierungs",
          kilometrierung_distance: "Km-Achsen",
          gleisachse_distance: "Gleisachsen",
          gleisachse_gap: "Gleisachsen",
          inspect: "Geo-Inspektion",
          inspect_active: "Geo-Inspektion",
          tile_inspect: "Prozess-Inspektion",
          gnd_inspect: "GIS-Inspektion",
        },
        processtypes: {
          ortho: "Ortho",
          plan: "Plan",
          dgm: "DGM",
        },
        trades: {
          "Brandschutz": "Brandschutz",
          "KIB/Oberbau": "KIB/Oberbau",
          "LST": "LST",
          "MTA": "MTA",
          "OLA": "OLA",
          "50 Hz": "50 Hz",
          "SiGeKo": "SiGeKo",
          "SÜ": "SÜ",
          "TK": "TK",
          "Sonstiges": "Sonstiges",
          "Übergreifend": "Übergreifend",
        },
        alerts: {
          invalid_trade: "Bitte ein gültiges Gewerk auswählen.",
          error_sending: "Beim Senden der Annotationsdaten an den Server ist ein Fehler aufgetreten.",
          error_connection: "Es besteht ein Problem bei der Verbindung mit der Annotationsdatenbank.",
          unsaved_header: "Ungespeicherte Annotation",
          unsaved_text: "Es existiert bereits eine ungespeicherte Annotation. Soll diese durch die neue Annotation überschrieben werden?",
          added_geom: "Geometrie hinzugefügt.",
          only_2d: "Aktuell können nur 2D-Annotationen angelegt werden. Bitte übertragen Sie die 3D Messung dazu ggf. auf die Karte.",
        },
      },

      // Search menu
      search: {
        search: "Suchen",
        kilometry: "Kilometrierung",
        show_km: "{{km}} anzeigen",
        show: "Anzeigen",
        coordinates: "Koordinaten",
        epsg: "EPSG",
        processes: "Prozesse",
        projects: "Projekte",
        places: "Orte",
        ivl: "IVL",
        search_history: "Suchverlauf",
        search_for: "Suchen nach...",
        places_example: "'Hamburg' / 'Stuttgart' / 'Rummelsburg'",
        coordinates_example: "'13.4 52.5'",
        epsg_example: "DBREF/WebMerc/WGS84",
        kilometry_example: "'6362' / '6362 50,5'",
      },

      // Functionalities
      func: {
        lstdetected: "Erkanntes LST-Objekt",
        connectedimages: "Verknüpfte Bilder",
        showimages: "Bilder anzeigen",
        hideimages: "Bilder ausblenden",
        multiple_gnd: "Mehrere GIS-Ebenen gefunden",
        km: "Kilometrierungslinie",
        tr: "Gleisachse",
        hm: "Hektometerpunkt",
        obj: "GIS-Objekt",

        geometry: "Geometrie",
        lineNumber: "Streckennummer",
        directionIndicator: "Richtungskennzeichen",
        km: "Kilometrierung",
        fromKm: "Kilometrierung",
        toKm: "Kilometrierung",
        label: "Anzeigetext",

        Point: "Punkt",
        MultiPoint: "Punkt",
        LineString: "Linie",
        MultiLineString: "Linie",
        Polygon: "Polygon",
        MultiPolygon: "Polygon",
      },

      // Share menu
      share: {
        copy_link: "Exportlink kopieren",
      },

      // Container management menu
      container: {
        switch_to: "Zur {{view}} wechseln",
        column: "Spaltenansicht",
        row: "Reihenansicht",
        auto_view_connect: "Neue Container automatisch synchronisieren",
        sync_rotation: "Rotation mitsynchronisieren",
        sync_zoom: "Zoom mitsynchronisieren",
        content_2d: "2D Karte",
        content_OPENLAYERS: "2D Map",
        content_INSPECT: "Geo-Inspektion",
        content_PROFILE: "Profil",
        content_3d: "3D-Viewer",
        content_POTREE: "3D Viewer",
        content_VIDEO: "Video",
        remove: "Entfernen",
        move: "Container verschieben",
        add_2d: "+2D",
        add_3d: "+3D",
      },

      // Toolbar
      tb: {
        distance_title: "Distanz messen",
        area_title: "Fläche messen",
        volume_title: "Volumen messen",
        volume_delta_title: "Volumendifferenz messen",
        marker_title: "Koordinatenmarker setzen",
        angle_title: "Winkel messen",
        height_title: "Höhendifferenz messen",
        profile_title: "Profile",
        kilometrierung_title: "Kilometrierung ermitteln",
        kilometrierung_distance_title: "Messen an Km-Achse",
        gleisachse_distance_title: "Messen an Gleisachse",
        gleisachse_gap_title: "Abstand zur Gleisachse",
        inspect_title: "Geo-Inspektion",
        inspect_active_title: "Geo-Inspektion",
        tile_inspect_title: "Prozess-Inspektion",
        gnd_inspect_title: "GIS-Inspektion",
        distance_help: "Messpunkte per Klick setzen, beim Beenden der Messung wird kein weiterer Punkt gesetzt.",
        area_help: "Eckpunkte der Fläche per Klick setzen, beim Beenden der Messung wird kein weiterer Punkt gesetzt.",
        volume_help: "Basisfläche Fläche per Klick festlegen, beim Beenden der Messung wird kein weiterer Punkt gesetzt. " +
          "Die Berechnung des Volumens erfolgt auf Grundlage eines zugehörigen Geländemodells. " +
          "Dies kann einen Moment dauern.",
        volume_delta_help: "Basisfläche per Klick festlegen, beim Beenden der Messung wird kein weiterer Punkt gesetzt. " +
          "Die Berechnung der Volumendifferenz erfolgt auf Grundlage der zugehörigen Geländemodelle. " +
          "Dies kann einen Moment dauern. " +
          "Zur Benutzung dieses Werkzeugs muss die Vergleichsfunktion aktiviert sein.",
        marker_help: "Marker per Klick setzen, beim Beenden der Messung wird kein weiterer Punkt gesetzt.",
        angle_help: "Insgesamt drei Punkte per Klick setzen. Dadurch ergeben sich zwei Geraden, die sich am zweiten Punkt schneiden. Der Winkel zwischen den Geraden wird gemessen.",
        height_help: "Messpunkte per Klick setzen, beim Beenden der Messung wird kein weiterer Punkt gesetzt.",
        profile_help: "Messpunkte des Profils per Klick setzen, beim Beenden der Messung wird kein weiterer Punkt gesetzt. " +
          "Die Berechnung des Profils erfolgt auf Grundlage einer zugehörigen Punktwolke.",
        kilometrierung_help: "Zunächst eine der geladenen Kilometrierungslinien anwählen, die Kilometrierungsmessung per Klick abschließen. " +
          "Für eine weitere Messung erneut mit dem Auswählen der Kilometrierungslinie beginnen.",
        kilometrierung_distance_help: "Zunächst eine der geladenen Kilometrierungslinien auswählen und einen Basispunkt wählen. " +
          "Danach Messungen vom Basispunkt durch erneutes Auswählen der Kilometrierungslinie beginnen.",
        gleisachse_distance_help: "Zunächst eine der geladenen Gleisachsen auswählen und einen Basispunkt wählen. " +
          "Danach Messungen vom Basispunkt durch erneutes Auswählen der Gleiskante beginnen.",
        profile_along_axis_title: "Profil entlang der Achse",
        profile_perpendicular_title: "Profil senkrecht zur Achse",
        axis_measurement_value: "Achsenmessung",
        axis_line_number: "Strecke",
        gleisachse_gap_2d_help: "Zunächst eine der geladenen Gleisachsen auswählen und die Abweichung kalibrieren: die grünen Hilfsschienen auf die Schienen im Orthofoto legen und klicken. Danach misst jeder Klick den Abstand zur kalibrierten Gleisachse.",
        gleisachse_gap_3d_help: "Zunächst eine der geladenen Gleisachsen auswählen. Danach misst jeder Klick den Abstand des Punktes zur Gleisachse.",
        gleisachse_gap_help: "Zunächst eine der geladenen Gleisachsen anuswählen und die Abweichung von der Gleisachse kalibrieren. " +
          "Danach erneut die Gleisachse auswählen und auf Basis der soeben kalibrierten Gleisachsenabweichung messen.",
        inspect_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder der aktivierten Prozesse angezeigt. " +
          "Durch Klicken auf diese Bildsymbole öffnet sich das Inspect-Fenster.",
        inspect_active_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder aller verfügbaren Prozesse angezeigt. " +
          "Durch Klicken auf die Bildsymbole öffnet sich das Inspect-Fenster.",
        tile_inspect_help: "Für den ausgewählten Punkt wird der sichtbare Prozess anzeigt.",
        gnd_inspect_help: "Durch Klicken auf GIS-Daten öffnet sich ein Inspect-Fenster. " +
          "Zur Benutzung dieses Werkzeugs muss mindestens eine GIS-Ebene auf der Karte aktiv sein.",
        edit_help: "Bearbeitung der Messung durch Drag & Drop der Eckpunkte. " +
          "Die Änderungen werden nach Beendigung der Bearbeitung ggf. automatisch in andere Viewer übertragen.",
        abort_changes: "Änderungen verwerfen",
        apply_changes: "Änderungen übernehmen",
        no_measurements: "Es sind noch keine Messungen vorhanden.",
        menu: "Menü",
        base: "Basisfunktionen",
        point: "Marker/Koordinaten",
        height: "Höhenmessungen",
        axis: "Achsenmessung",
        inspect: "Inspektion",
        active_measurement: "Messung aktiv",
        finish_measurement: "Messung beenden",
        finish_measurement_click: "Beenden der Messung mit Rechtsklick",
        annotation_name: "TEMPORÄR: {{measurement}}",
        annotation_status: "aktiv",
        annotation_text: "Annotationsbeschreibung",
        show: "{{profile_name}} anzeigen",
        hide: "{{profile_name}} ausblenden",
        active: "aktiv",
        create_annotation: "Annotation erzeugen",
        edit_measurement: "Messung bearbeiten",
        delete_measurement: "Messung löschen",
        process_detected: "Erkannter Prozess",
        no_process: "Hier sind keine Daten aktiviert",
        date: "Datum",
        process_id: "Prozess-ID",
        process_type: "Prozesstyp",
        process_title: "Titel",
        process_description: "Beschreibung",

        alerts: {
          coming_soon: "Demnächst verfügbar.",
          wrong_container: "Annotationen können nur aus Messungen erstellt werden die auf Orthobildern erzeugt oder auf Orthobilder übertragen wurden.",
          too_many_points: "Im Moment dürfen Messungen zur Umwandlung in Annotationen nicht mehr als 16 Eckpunkte enthalten. Bitte legen Sie eine neue Messung an.",
          no_ortho: "Für das Anlegen einer Annotation muss sich die Messung auf einem Orthobild befinden.",
          need_compare: "Um dieses Werkzeug nutzen zu können, muss die Vergleichsfunktion aktiviert sein. " +
            "Rechtsklick zum Beenden.",
          need_gnd: "Um dieses Werkzeug nutzen zu können, muss mindestens eine GIS-Ebene auf der Karte aktiv sein. " +
            "Rechtsklick zum Beenden.",
          need_ortho: "Für die Geoinspekt-Funktion muss mindestens ein Orthobild aktiv sein.",
          need_2d: "Die Benutzung dieses Werkzeugs ist nur auf einer Karte möglich. " +
            "Rechtsklick zum Beenden.",
          need_3d: "Die Benutzung dieses Werkzeugs ist nur in einer Punktwolke möglich. " +
            "Rechtsklick zum Beenden.",
          measurement_not_in_container: "Die zum Bearbeiten ausgewählte Messung befindet sich in einem anderen Viewer.",
          measuring_in_other_container: "Sie arbeiten bereits in einem anderen Viewer. " +
            "Rechtsklick zum Beenden.",
          editing_in_other_container: "Sie arbeiten bereits in einem anderen Viewer.",
        },
      },

      // Info Container
      ic: {
        collapse: "Infocontainer einklappen",
        expand: "Infocontainer ausklappen",
        rotate_north: "Karte einnorden",
        rotate_45: "Karte 45° rotieren",
        hide_view_cone: "3D-Sichtfelder sichtbar",
        show_view_cone: "3D-Sichtfelder ausgeblendet",
        stop_axis_navigation: "Navigation an Achse beenden",
        start_axis_navigation: "Navigation an Achse starten",
        select_axis: "Bitte Gleisachse auswählen",
        cancel: "Abbrechen",
        forward: "Vorwärts [(Strg+)(⇧+) X]",
        backward: "Rückwärts [(Strg+)(⇧+) Y]",
        change_direction: "Richtung ändern",
        next_pano: "↑ [.]",
        prev_pano: "↓ [,]",
        decouple: "Ansicht synchronisiert",
        couple: "Ansicht nicht synchronisiert",
        log_measurements: "Messungen loggen",
        log_map: "Karte loggen",
        leave: "Panorama verlassen",
        hide: "Punktwolken sichtbar",
        show: "Punktwolken ausgeblendet",
        log_viewer: "Viewer loggen",
        orbit: 'Kameraeinstellung "Orbit-Modus"\n' +
          "Rotation um Fokuspunkt\n" +
          "Bewegung in Kameraebene",
        earth: 'Kameraeinstellung "Earth-Modus"\n' +
          "Rotation um Klickpunkt\n" +
          "Bewegung in Bodenebene",
        ego: 'Kameraeinstellung "First-Person"\n' +
          "Rotation um Kameraposition\n" +
          "Bewegung in Kameraebene\n" +
          "- Horizonzal mit Pfeiltasten\n" +
          "- Vertikal mit Bild auf / ab",
        top_down: 'Draufsicht',
        down_top: 'Untersicht',
        side_front: 'Vorderansicht',
        side_back: 'Hinteransicht',
        side_left: 'Seitenansicht (links)',
        side_right: 'Seitenansicht (rechts)',
        profile: "Profil {{name}}",
        brightness: 'Helligkeit',
        intensity: 'Sättigung',
        reset: "Höhe zurücksetzen",
        syncall: "Alle Bewegungen synchronisieren",
        synctransl: "Translation/Bewegung synchronisieren",
        syncrot: "Rotation synchronisieren",
        synczoom: "Zoom synchronisieren",
      },
    },

    support: {
      supportTittle: "Support",
      supportIntro: "Bitte schauen Sie bei Fragen oder Problemen zunächst im <0>X2BIM Wiki</0> nach. Dort finden Sie hilfreiche Informationen, Anleitungen und Antworten auf häufige Fragen.",
      supportContact: "Sollten Sie fachliche Fragen haben, wie z.B. Fragen zu Projektfreischaltungen, wenden Sie sich bitte an die folgende Kontaktstelle: <0>{{email}}</0>",
      supportGeneral: "Für allgemeine Anfragen zu X2BIM nutzen Sie bitte das folgende Formular. Beschreiben Sie Ihr Anliegen möglichst genau und fügen Sie bei Bedarf Anhänge (PNG, JPG oder PDF) hinzu.",
      message: "Nachricht an den X2BIM-Support",
      close: "Abbrechen",
      send: "Senden",
      addFileTittle: "Dateien hinzufügen",
      sent: "gesendet",
      failed: "Nachricht konnte nicht gesendet werden",
    },

    changelogs: {
      title: "News"
    },

    customerSettings: {
      title: "Einstellungen",
      geoServices: {
        title: "Externe Geo-Dienste",
        add: "Hinzufügen",
        empty: "Keine externen Geo-Dienste vorhanden.",
        createTitle: "Neuen Geo-Dienst erstellen",
        editTitle: "Geo-Dienst bearbeiten",
        deleteTitle: "Geo-Dienst löschen",
        deleteConfirm: "Möchten Sie diesen Geo-Dienst wirklich löschen?",
        nameLabel: "Name",
        urlLabel: "URL",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        validationError: "Name und URL sind Pflichtfelder.",
        configValidationError: "Das Feld \"{{field}}\" ist erforderlich.",
        typeLabel: "Typ",
        configSection: "Konfiguration",
        getCapabilities: "Capabilities abrufen",
        capabilitiesHint: "URL eingeben und 'Capabilities abrufen' klicken, um die Konfigurationsoptionen zu laden.",
        capabilitiesSuccess: "Verbindung erfolgreich. Konfigurationsoptionen wurden geladen.",
        capsFailed: "GetCapabilities fehlgeschlagen",
        capsCorsFailed: "Verbindung fehlgeschlagen. Der Server erlaubt möglicherweise keine ursprungsübergreifenden Anfragen (CORS).",
        config: {
          layers: "Layer",
          layer: "Layer",
          format: "Format",
          version: "Version",
          projection: "Projektion",
          matrixSet: "MatrixSet",
          tmsY: "TMS Y-Achse (Y=0 unten, invertiert)",
        },
      },
    },

    leftNav: {
      dashboard: "Alle Projekte",
      viewer: "Viewer",
      labeling3d: "3D-Labeling",
      sbb: "Clearance Inspector",
      betaViewer: "MapLibre Viewer",
      uploader: "Uploader",
      projects: "Projekte",
      processes: "Prozesse",
      tools: "Tools",
      management: "Verwaltung",
      userManagement: "Benutzer",
      language: "Sprache",
      help: "Hilfe",
      faq: "FAQ",
      wiki: "Wiki",
      logout: "Abmelden",
      account: "Konto",
      userManual: "Benutzerhandbuch",
      support: "Unterstützung",
      credit: "Controlling",
      finance: "iV Controlling",
      bim: "BIM-Viewer (BETA)",
      nextgen: "NextGen",
      customerSettings: "Einstellungen",
    },

    accountSettings: {
      title: "Benutzereinstellungen",
      userName: "Nutzername",
      role: "Rolle",
      communicationEmail: "Kontakt-Mailadresse",
      change: "Ändern",
      save: "Speichern",
      cancel: "Abbrechen",
      close: "Schliessen",
      invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      emailUpdated: "Kontakt-Mailadresse aktualisiert",
      emailUpdateFailed: "Kontakt-Mailadresse konnte nicht aktualisiert werden",
      emailNotConfirmed: "Diese E-Mail-Adresse wurde noch nicht bestätigt.",
      newsletter: "Newsletter/Updates erhalten",
      newsletterUpdated: "Newsletter-Einstellung aktualisiert",
      newsletterUpdateFailed: "Newsletter-Einstellung konnte nicht aktualisiert werden",
      deleteAccount: "Delete Account",
      deleteConfirm: "Möchten Sie die Löschung Ihres Kontos beantragen? Unser Support-Team meldet sich bei Ihnen.",
      deleteRequested: "Löschanfrage gesendet",
      deleteFailed: "Löschanfrage konnte nicht gesendet werden",
      news: "News erhalten",
    },

    dashboard: {
      yourProject: "Ihre Projekte ({{count}})",
      overview: "Dashboard",
      noCustomerWarning: "Sie sind bisher noch keinem Kunden zugewiesen. Bitte melden Sie sich bei Ihrem Administrator.",
      noLinkedCustomer: "Kein Kunde zugewiesen",
      noProjectWarning: "Keine Projektberechtigung zugewiesen! Bitte melden Sie sich bei dem Projektteam!",
      search: "Suche",
      projectCard: {
        processes: "Prozesse",
        showAll: "Alle anzeigen"
      },
      table: {
        search: "Suche",
        projectTitle: "Projekttitel",
        processCount: "Prozessanzahl",
        epsg: "EPSG",
        openInApp: "In der App öffnen"
      },
      apps: {
        viewer: "Viewer",
        uploader: "Upload Data",
        projects: "Projekte",
        processes: "Prozesse"
      },
      jumpTo: "Gehe zu",
      pd: {
        selectionNeeded: "Bitte wählen Sie zuerst ein Projekt aus",
        deleteModalContent: "Wollen Sie das ausgewählte Projekt und alle dazugehörigen Daten/Prozesse wirklich unwiderruflich löschen?",
        update: "Aktualisieren",
        discard: "Änderungen verwerfen",
        selection: "Ausgewähltes Projekt",
        create: "Erstellen",
        noProjectCreated: "Das Projekt konnte nicht erstellt werden",
        noProjectUpdated: "Das Projekt konnte nicht aktualisiert werden",
        details: "Information",
        groupTitles: {
          generalInfo: "Allgemeine Informationen",
          controllingMetadata: "Controlling-Metadaten",
          dataViewer: "Datenviewer"
        },
        administration: {
          title: "Administration",
          processesText: "hochgeladene Prozesse",
          usersText: "hinzugefügte Benutzer"
        },
        boundary: "Bereiche",
        defaultViewer: "Standard viewer",
        viewerSettings: {
          title: "Viewer Einstellungen ",
          discontinuedWarning: "Achtung: Prozesssortierungen ist veraltet und wird zukünftig entfernt.",
          processSortings: {
            title: "Prozesssortierungen (Veraltet)",
            description: "Setzt die Standardsortierung für die sichtbaren Prozesse im Viewer",
            selectedType: "Ausgewählter Typ",
            resetAll: "Alle zurücksetzen",
            sortBy: "Sortieren nach",
            resetSelected: "Auswahl zurücksetzen"
          }
        },
        pboundary: "{{- projectName}} Bereiche",
        pgnd: "{{- projectName}} GIS/GND",
        userAccess: "Projektberechtigungen",
        createProject: "Projekt erstellen",
        projects: "Projekte",
        projectSelection: "Projektauswahl",
        projectUAcess: "{{- projectName}} Projektberechtigungen",
        projectProcess: "{{- projectName}} Prozessliste",
        projectProcessAccess: "{{- projectName}} Prozessberechtigungen",
        openProject: "Öffnen",
        newProject: "Projekt erstellen",
        uploadProjectImage: "Projektbild hochladen",
        projectCreateMessage: "Projekt erstellt",
        projectName: "Projektname",
        logoUploaded: "Projektlogo hochgeladen",
        logoLoaded: "Logo geladen",
        customerName: "Kundenname",
        projCode: "Projekt-Code",
        projDuration: "Projektlaufzeit",
        years: "Jahre",
        desc: "Projektbeschreibung",
        coord: "Koordinatensystem",
        accounting: "Accounting",
        unallocatedAccount: "unbestimmtes Kontierungsziel",
        accountAllocation: "Kontierungsziel",
        fromCreditBalance: "aus Guthaben",
        plannedCredit: "Geplante Credit(s)",
        dataOwner: "Dateninhaber",
        mmSize: "Größe Mobile Mapping",
        pcSize: "Größe Punktwolken",
        heliSize: "Größe Helikopter",
        flightArea: "Flugbereich",
        gigaPixel: "GigaPixel",
        uploadKML: "Upload KML",
        addKML: "+ KML",
        or: "ODER",
        save: "Speichern",
        delete: "Delete",
        uploadKMLTitle: "Projekt-KML hochladen",
        dragFile: "Datei hierher ziehen",
        fileExplorer: "Datei-MenuBar öffnen",
        userRemoved: "Nutzer entfernt",
        userAdded: "Nutzer hinzugefügt",
        addUser: "Nutzer hinzufügen",
        addAccount: "Konto hinzufügen",
        editAccount: "Rollen bearbeiten",
        inviteUser: "Benutzer nicht gefunden",
        inviteOrProvisionUserMessage: "Der Benutzer {{email}} existiert nicht auf der Plattform. Sie haben zwei Möglichkeiten: Sie können den Benutzer vorübergehend provisionieren, bis er sich zum ersten Mal mit einem bekannten Identity Provider anmeldet, oder Sie senden ihm eine Einladung, um sich beim Identity Provider von x2bim.com zu registrieren.",
        provisionUserMessage: "Der Benutzer {{email}} existiert nicht auf der Plattform. Sie können den Benutzer vorübergehend provisionieren, bis er sich zum ersten Mal mit seinem Identity Provider anmeldet.",
        sendInvitation: "Einladung senden",
        provisionUser: "Benutzer provisionieren",
        users: "Nutzer",
        roles: "Rollen",
        add: "Hinzufügen",
        cancel: "Abbrechen",
        name: "Name",
        remove: "Entfernen",
        export: "Exportieren",
        action: "Aktion",
        removeWarning: "Sind Sie sicher, dass Sie die Aufnahme entfernen wollen?",
        projectCreate: "Projekt erstellen",
        projectDelete: "Projekt löschen",
        projectUpdate: "aktualisieren",
        gnd: "GIS/GND",
        layers: "Ebenen",
        layerType: "Ebenentyp",
        editLayer: "{{name}} bearbeiten",
        kilometerline: "Kilometrierte Linie",
        trackline: "Gleisachse",
        hectometerpoints: "Hektometerpunkte",
        trackdataDbigo: "DB IGO Gleisnetzdaten",
        kilometerLineSegment: "Strecken (Kilometrierung)",
        trackEdgeSegment: "Gleiskanten (Stationierung)",
        miscellaneous: "Sonstiges",
        wms: "WMS-Dienste (Experimentell)",
        tracktopography: "SBB Gleistopografie",
        addNewLayer: "Neue Ebene hinzufügen",
        layerName: "Ebenenname",
        unnamedLayer: "Unbenannte Ebene",
        layerColor: "Ebenenfarbe",
        layerDimensions: "Ebenendimension",
        invalidHexString: "Ungültiger Hex-Code",
        uploadError: "Unerwarteter Fehler. Bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns, wenn das Problem weiterhin besteht.",
        layerDeleteMsg: "Sind Sie sicher, dass Sie die Ebene und alle dazugehörigen Objekte löschen wollen?",
        edit: "Bearbeiten",
        noUploadsYet: "Sieht so aus, als hätte diese Ebene noch keine Uploads. Fügen Sie als Erster mit dem roten Plus welche hinzu.",
        createNewUpload: "Neue Daten hochladen",
        deleteUpload: "Wollen Sie die hochgeladenen Daten vom {{date}} und alle dazugehörigen Objekte löschen?",
        deleteUploadTitle: "Hochgeladene GIS/GND-Daten '{{ uploadToDelete }}'",
        newUpload: "Neue GIS/GND-Daten",
        correspondingUploadedData: "GIS/GND-Daten",
        forLayer: "für Ebene ",
        targetType: "Zieltyp",
        Gleispunkte: "Gleispunkte",
        tunnels: "Tunnel",
        kilometerLine: "Linienkilometrierung",
        kilometerOrientation: "Linienorientierung",
        inputFileSelection: "Dateiauswahl",
        tracks: "GTG-Strang-Namen",
        tracktopographyInfo: "Bitte beachten Sie die korrekte Zuordnung der CSV-Dateien. Dies ist sehr wichtig. Bei falscher Zuordnung können keine Daten angelegt werden. Beispiel: Namen der GTG-Abschnitte (gtg_strang_neid.csv), Gleispunkte (gleispunkte.csv), Tunnel (tunnel.csv), Kilometerangaben der Strecken (linien_kilometrierung.csv), Orientierung der Strecken (linien_orientierung.csv).",
        selectFile: "Datei auswählen",
        requiredEPSG: "Erforderlicher EPSG: 3857",
        requiredEPSGDbigo: "Erforderlicher EPSG: 4326",
        supportedGeometryTypes: "Unterstützte Geometrie-Typen: ",
        jsonNoFeatures: "GeoJSON muss mindestens ein Feature beinhalten.",
        jsonMultipleTypes: "GeoJSON besteht aus mehreren Geometrie-Typen. Nur Kollektionen mit einem Typen sind bis jetzt erlaubt.",
        jsonUnsupportedType: `Nicht unterstützter Geometrie-Typ {{unsupportedType}} in GeoJSON. Benutzen Sie entweder Point oder MultiLineString.`,
        gndAddTitle: "Neue Elemente hinzufügen",
        gndError: "Ebene konnte nicht gespeichert werden. Bitte versuche es später erneut.",
        gndSuccess: "Ebene erfolgreich gespeichert. Du kannst diesen nun manuell im Viewer einblenden.",
        gndSubmit: "Hinzufügen",
        attributeMapping: "Attributzuordnung",
        gndPointType: "Punkt-Typ",
        gndLineType: "Linien-Typ",
        selectJson: "GeoJSON auswählen",
        gndNameKey: "Namen-Attribut",
        gndKmKey: "Km-Attribut",
        gndLineKey: "Strecken-Nummer-Attribut",
        gndTrackKey: "Gleis-Unterscheidungsmerkmal",
        gndKmStartKey: "Start-Km-Attribut",
        gndKmEndKey: "Ende-Km-Attribut",
        gndSimpleType: "Einfach",
        gndKilometerizedType: "Kilometriert",
        gndGroups: "Gruppen",
        manageGndGroups: "Layergruppe und deren Sichtbarkeit verwalten",
        gndGroupsCreate: "Layergruppe",
        noGroups: "Es sind noch keine Layergruppen vorhanden.",
        editGroup: "Layergruppe bearbeiten",
        createGroup: "Layergruppe erstellen",
        actions: "Aktionen",
        noLayers: "Es sind noch keine Layer vorhanden. Erstelle eine mit dem roten Plus.",
        addLayerToGroup: "Layer zur Gruppe hinzufügen",
        layerGroupLabel: "Layergruppe",
        order: "Reihenfolge",
        createFirstGroup: "Erstelle die erste Gruppe",
        confirmDeleteGroup: "Möchten Sie die Layergruppe wirklich löschen?",
        additionalAttributes: "Weitere Attribute",
        objectExport: "LRPO-Export",
        deleteRoles: "Bist du sicher, dass du diesen Benutzer vom Kunden entfernen möchtest?",
      },
      processes: {
        selection: "Auswahl",
        processes: "Prozessliste",
        userAccess: "Prozessberechtigungen",
        procArchived: "Prozess gelöscht",
        procDeleted: "Prozesslöschung ausgelöst! Es kann einige Zeit dauern, bis dieser Vorgang abgeschlossen ist.",
        procArchivedFailed: "Löschen des Prozesses fehlgeschlagen",
        tableCompact: "Kompakt",
        tableFull: "Voll",
        pID: "ID",
        pTitle: "Titel",
        pDesc: "Beschreibung",
        pType: "Typ",
        pStatus: "Status",
        all: "Alle",
        allWithoutDeleted: "Alle außer Gelöschten",
        pSourceDate: "Quelldatum",
        pInitDate: "Prozessdatum",
        pTags: "Tags",
        actions: "Aktionen",
        actionsAdmin: "Admin Aktionen",
        actionsEdit: "Bearbeiten",
        downloadReport: "Bericht herunterladen",
        internal: "Intern",
        external: "Extern",
        standardUserAccess: "Zugriff",
        grantStandardUserAccess: "Zugriff für Standardnutzer gewähren",
        revokeStandardUserAccess: "Zugriff für Standardnutzer entziehen",
        usedStorageMB: "Genutzter Speicher",
        creditsConsumed: "Verbrauchte Credits",
        usedStorageShort: "Speicher",
        creditsConsumedShort: "Credits",
        archive: "Löschen",
        close: "Schließen",
        addTagToProcess: "+ Tag zum Prozess hinzufügen",
        selectOrCreateTag: "Wählen oder erstellen Sie einen Tag",
        deleteProcessMsg: "Wollen Sie den Prozess löschen?",
        areYouSure: "Sind Sie sicher?",
        reparseSensors: "Sensoren neu erstellen",
        reparseConfirmTitle: "Wollen Sie die Sensoren neu erstellen?",
        reparseConfirmDescription: "Diese werden auf basis von Bestandsdaten aus dem Storage erstellt.",
        confirmText: "Möchten Sie den Standardbenutzerzugriff für {{count}} ausgewählte Prozesse wirklich {{status}}?",
        activate: "Ausgewählte aktivieren",
        deactivate: "Ausgewählte deaktivieren",
        enableAccess: "aktivieren",
        disableAccess: "deaktivieren",
        accessPermissionMissing: "Sie haben keine Berechtigung, den Prozesszugriff zu ändern.",
        accessFinishedOnly: "Der Zugriff kann nur für abgeschlossene Prozesse geändert werden.",
        processAccessGranted: "Der Standardbenutzer erhielt Ansichtszugriff auf Prozess '{{processTitle}}'.",
        processAccessRevoked: "Der Ansichtszugriff für Standardbenutzer auf Prozess '{{processTitle}}' wurde entzogen.",
        bulkProcessAccessGranted: "Der Ansichtszugriff für Standardbenutzer wurde für {{count}} ausgewählte Prozesse erteilt.",
        bulkProcessAccessRevoked: "Der Ansichtszugriff für Standardbenutzer wurde für {{count}} ausgewählte Prozesse entzogen.",
        processeCopy: "Kopieren",
        copyId: "Copy ID",
        idCopied: "Id Copied",
        copyText: "Projekt: {{projectName}} in anderes Projekt kopieren",
        copyPermissionMissing: "Sie haben keine Berechtigung, Prozesse zu kopieren.",
        copyFinishedOnly: "Nur abgeschlossene Prozesse können kopiert werden.",
        copyNoDestination: "Kein anderes Projekt hat ein passendes EPSG.",
        copyBackgroundNotice: "Der Kopiervorgang wird im Hintergrund ausgeführt und kann einige Minuten dauern.",
        copyDestination: "Zielprojekt: {{projectName}}",
        copyCredits: "Geschätzte Kosten: {{count}} Credits",
        copyStarting: "Kopiervorgang wird gestartet",
        selectProject: "Zielprojekt auswählen",
        copyConfirmText: "Möchten Sie die ausgewählten Prozesse in das Projekt '{{projectName}}' kopieren?",
        copySuccessMessage: "Der Kopiervorgang für {{count}} Prozess(e) wurde gestartet. Dies kann einige Minuten dauern.",
        copyFailedMessage: "Fehler beim Starten des Kopiervorgangs.",
        copyInfo: "Wählen Sie Prozesse aus, die in ein anderes Projekt kopiert werden sollen. Der Kopiervorgang wird im Hintergrund ausgeführt und Sie werden benachrichtigt, sobald dieser abgeschlossen ist. Je nach Anzahl und Größe der Prozesse kann dies einige Zeit dauern.",
        aiClasses: "KI-Klassenverwaltung",
        statusChanged: "Status geändert",
      },
      objectExport: {
        warning: "Probleme beim Abfragen der Befahrungen",
        confirm: "Bitte bestätigen",
        confirm_text: `Wenn Sie diesen Export bestätigen, wird/werden {{count}} Objekt(e) exportiert.`,
        export: "Export",
        heading: "Objektexport nach LIRA",
        text: 'Wählen Sie einzelne Befahrungen aus, um Objekte nach LIRA zu exportieren. Exportierbar sind Objekte im Status "geschlossen". Es werden Ihnen nur Befahrungen angezeigt, die mindestens ein geschlossenes Objekt beinhalten.',
        p_disc: "Beschreibung",
        date: "Datum",
        open: "offen",
        closed: "geschlossen",
        exported: "exportiert",
        noItem: "Bisher gibt es noch keine Objekte zum Exportieren.",
        exportSuccessMessage: `Der Export von {{count}} Objekt(en) wurde gestartet. Dies kann einige Minuten dauern. Wenn die Objekte erfolgreich exportiert wurden, befinden sie sich im Zustand "exportiert".`,
        exportButton: `Exportiere {{count}} Befahrung(en)`,
        loading: "Lade exportierbare Befahrungen..."
      }
    },

    homePage: {
      dashboardLink: "Zur App",
      platform: "Die Plattform",
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      dataText: "Infrastruktur aus X Perspektiven",
      point1: "Spezialisiert auf lange Strecken und Großprojekte",
      point2: "DSGVO-konforme Anonymisierung mittels KI",
      point3: "Enterprise „Single Sign On“ (u.a. M365)",
      point4: "Computer Vision / KI-gestützte Objekterkennung in 2D und 3D",
      point5: "Entwicklung kundenspezifischer KI-Module",
      point6: "Bilddaten, Orthobilder und Punktwolken",
      point7: "Performante Lösung zur Prozessierung von 2D/3D-Daten",
      point8: "Modell- (IFC) und Plan- (DWG) Integration",
      point9: "UAV-, Helikopter-, mobile Mapping-,BIM- Gleisnetzdaten und terrestrisches Laserscanning in einer Plattform",
      text1: "Messen in 3 Dimensionen",
      text2: "Multitemporale Datenanalyse",
      text3: "Gleisachsen- und Kilometrierungsfunktionen",
      text4: "Multidimensionale Visualisierung",
      description: "Moderne Infrastrukturprojekte erfordern innovative Lösungen und neue Perspektiven. " +
        "Mit X2BIM als gemeinsame Plattform für Befliegungen (UAS), terrestrische Laserscandaten und mobile Mapping steigern Sie nicht nur die Effizienz im Projekt, sondern gewinnen auch X neue Einblicke in Ihre Daten. " +
        "Vergleichen Sie Ihre CAD-Pläne und BIM-Modelle mit 3D-Punktwolken oder hochauflösenden Orthophotos einfach im Web und monitoren Sie Ihre Baustelle vor Ort!",
      moreInfo: "Erfahren Sie mehr...",
    },

    //User Management
    um: {
      accounts: "Benutzerkonten"
    },

    notify: {
      roleSuccess: "Rollen gespeichert",
      userAddedToCustomer: "Benutzer zum Kunden hinzugefuegt",
      rolesFailed: "Fehler beim Speichern von Rollen",
      invitationSent: "Einladung erfolgreich gesendet",
      invitationFailed: "Fehler beim Senden der Einladung",
      provisionFailed: "Fehler beim Provisionieren des Benutzers",
      addUserFailed: "Fehler beim Hinzufügen des Benutzers",
      maxUsersReached: "Die maximale Anzahl an Benutzern für diesen Kunden wurde erreicht",
      userAlreadyInCustomer: "Dieser Benutzer ist bereits im Kunden vorhanden. Um weitere Rollen zuzuweisen, verwenden Sie die Bearbeiten-Aktion in der Benutzertabelle.",
      noActiveProject: "Kein aktives Projekt",
      confirm: "Bitte bestätigen ",
      confirmDeleteProjectMessage: "Möchten Sie dieses Projekt wirklich löschen?",
      confirmAction: "Ja",
      cancel: "Nein",
    },

    messages: {
      loginErrorTittle: "Sitzung abgelaufen!",
      loginError: "Ihre Sitzung wurde wegen Inaktivität beendet. Bitte erneut einloggen!",
      login: "Anmelden",
      logOut: "Abmelden",
      pricingButton: "Preise",
      x2bimToInfraviewButton: "X2BIM auf Infraview",
      requestADemoButton: "Demo anfordern",
      agbsButton: 'ALB',
      notAllowed: "Zugang verwehrt",
      notAllowedMessage: "Sie wurden bisher zu keinem Projekt zugewiesen oder Sie verfügen nicht über die entsprechende Berechtigung. Bitte informieren Sie Ihren Projektansprechpartner, um die Freischaltung ggf. durchzuführen.",
      goBack: "Zurück",
      apiError: "Die Verbindung mit dem Server ist fehlgeschlagen. Versuchen Sie es erneut",
      tryAgain: "Erneut verbinden",
      apiIssue: "Anfrage fehlgeschlagen mit Status {{statusCode}}.",
      errorTittle: "Es ist ein Fehler aufgetreten :( !",
      progressSaved: "Fortschritt gespeichert",
      noActiveProject: "Kein aktives Projekt!",
      onlyPNG: "Nur PNG Dateien sind erlaubt, bitte stellen Sie sicher, dass das richtige Dateiformat verwendet wird!",
    },

    uploadModal: {
      dropFileHere: "Datei hierher ziehen",
      clickOrDrop: "Zum Auswählen klicken oder Datei hierher ziehen",
      selectFile: "Datei auswählen",
      parsingFailed: "Parsing der Datei fehlgeschlagen",
      acceptedFileTypes: "Unterstützte Dateiformate: ",
    },

    credit: {
      transactions: "Transactions",
      projectClosed: "Abgeschlossene Transaktion nach Projekt",
      projectOpen: "Offene Transaktion nach Projekt",
      titleCustomer: "{{customer}}",
      titleCredits: "Credit-Bilanz: {{credit}}",
      noActiveCustomer: "Kein aktiver Kunde! Bitte wählen Sie einen Kunden vom Seitenmenü aus.",
      noTxns: "Keine durchgeführten Transaktionen",
      consumptionDetails: "Details zum Verbrauch pro Projekt",
      noProjectWiseConsumption: "Keine verbrauchten Credits",
      creditTxns: "Credit-Transaktionen",
      creditTxnsAll: "Credit-Transaktionen aller Kunden",
      balanceCustomers: "Credit-Bilanz pro Kunde",
      txnDate: "Transaktionsdatum",
      creditIncome: "Eingang Credits",
      creditConsumed: "Verbrauchte Credits",
      txnStatus: "Status",
      txnDescription: "Beschreibung",
      addedBy: "Benutzer",
      open: "Open",
      close: "Closed",
      project: "Projekt",
      consumedBy: "Verbraucht durch",
      sum: "Summe",
      year: "Jahr",
      "January": "Januar",
      'February': "Februar",
      'March': "März",
      'April': "April",
      'May': "Mai",
      'June': "Juni",
      'July': "Juli",
      'August': "August",
      'September': "September",
      'October': "Oktober",
      'November': "November",
      "December": "Dezember",
      customerBalance: "Kundenbilanz",
      consumptionPerCustomer: "Verbrauch pro Kunde",
      addTxn: "Neue Transaktion hinzufügen",
      customer: "Kunde",
      addTxnButton: "Transaktion hinzufügen",
      add: "Hinzufügen",
      change: "Bearbeiten",
      customerId: "Kunden-ID",
      txnType: "Transaktionstyp",
      amount: "Betrag",
      desc: "Beschreibung",
      negativeTxn: "Negativtransaktionen",
      positiveTxn: "Positivtransaktionen",
      balance: "Bilanz",
      CreditAdded: "Credits hinzufügen",
      CreditRemoved: "Credits entfernen",
      credits: "Credit(s)",
      dateRange: "Zeitspanne",
      startDate: "Startdatum",
      endDate: "Enddatum",
      apply: "Anwenden",
      trendcreditconsumption: "Entwicklung Credit Verbauch",
      trendView: "Trend",
      monthlyStackView: "Monatsstapel",
      dailyStackView: "Tagesstapel",
      topCustomersView: "Top-Kunden",
      creditConsumption: "Creditverbrauch",
      creditBalance: "Credit Bilanz",
      cr_txn: "Credit-Transaktionen",
      pleaseSelectDate: "Bitte wählen Sie ein Startdatum für die Anzeige der Prozessdaten.",
      monthlyView: "monatlich",
      procssControll: "Prozessskontroll",
      quickFilter: "Quick filter für Prozesstypen und Datumsbereich",
      processType: "Prozesstyp",
      selectAll: "Prozesstyp",
      startDate: "Startdatum",
      endDate: "Enddatum",
      processOverview: "Übersicht über Prozesse",
      avgDurationMinutes: "durchs. Dauer (Minuten)",
      avgDurationHours: "durchs. Dauer (Stunden)",
      noProcess: "Es sind keine Prozessdaten verfügbar.",
      "processInsights": "Prozesseinblicke",
      table: "Tabelle",
      chart: "Diagramm",
      userRanking: "Benutzerranking",
      status: "Prozessstatus",
      processTitle: "Prozesstitel",
      projectName: "Projektname",
      uploadDate: "Upload-Datum",
      uploadFinishDate: "Upload-Abschlussdatum",
      uploadedBy: "hochgeladen von",
      topUploaders: "Top-Uploader",
      day: "Tag",
      month: "Monat",
      year: "Jahr",
      user: "User",
      period: "period",
      uploads: "Uploads",
      totalStorage: "Gesamtspeicher",
      processId: "Prozess-ID",
      processName: "Prozesstyp",
      storageGB: "Speicher (GB)",
      filters: "Filter",
      allOption: "Alle",
      selectedCount: "{{count}} ausgewählt",
      clearSelection: "Auswahl löschen",
      dateFrom: "Von",
      dateTo: "Bis",
      creditConsumptionTrend: "Trend Credit Verbrauch",
      accumulated: "Akkumuliert",
      aggregated: "Aggregiert",
      groupBy: "Gruppieren nach",
      groupByStatus: "Status (Offen/Geschlossen)",
      timeWindow: "Zeitraum",
      noDataAvailable: "Keine Daten für die gewählten Filter verfügbar.",
      exportCsv: "CSV exportieren",
      collapseGroup: "Gruppe einklappen",
      expandGroup: "Gruppe ausklappen",
      ivProjectId: "iV Projekt-ID",
      projectCode: "Projektcode",
      accountAllocation: "Kontierungsziel",
      date: "Datum",
      transactionType: "Transaktionstyp",
      processPID: "Prozess (PID)",
      runningBalance: "Laufendes Guthaben",
      errorLoading: "Fehler beim Laden: {{message}}",
      infrastructure: "Infrastruktur",
      transactionsCount_one: "{{count}} Transaktion",
      transactionsCount_other: "{{count}} Transaktionen",
    },

    notFound: {
      fourZeroFour: "404: Seite nicht gefunden",
      helpMsg: "",
      goBackToStart: "Zurück zum Start",
      resultsNotFound: "Nichts gefunden...",
    },

    labeling: {
      abortSetClass: "Abbrechen",
      noEditingServiceActive: "Kein Labeling-Service aktiv",
      type: "Typ",
      segment: "Segment",
      instance: "Instanz",
      cut: "Schnitt",
      focusCut: "Schnitt fokussieren",
      toggleInsideOutside: "Schnitt Innen/Außen umschalten",
      toggleCutActive: "Schnitt deaktivieren/aktivieren",
      handleDeleteCut: "Schnitt löschen",
      editLabel: "Label bearbeiten",
      selectClass: "Klasse auswählen",
      editingLine1: "Polygonauswahl aktiv: Polygonpunkte mit Linksklick setzen und mit Rechtsklick abschließen.",
      editingLine2: "Während der Bearbeitung ist die Navigation mit der Maus deaktiviert.",
      labeledObjects: "Gelabelte Objekte",
      abortChanges: "Änderungen verwerfen",
      cancel: "Änderungen verwerfen",
      saveChanges: "Änderungen speichern",
      deleteLabel: "Label löschen",
      addCut: "Schnitt hinzufügen",
      highlight: "Das Label farblich markieren",
      highlightButton: "Hervorheben",
      onlyLabel: "Nur das Label anzeigen",
      onlyLabelButton: "Nur Label",
      changeClass: "Objektklasse ändern",
      hideAllClasses: "Alle ausblenden",
      loadAllLabels: "Alle Labels in allen Zellen laden",
      loadingLabels: "Laden…",
      showAllClasses: "Alle einblenden",
      choosePointCloud: "Punktwolke auswählen",
      availableClassesNr: "verfügbare Objektklassen",
      classes: "Klassen",
      resetView: "Ansicht reset",
      addLabel: "+ Label hinzufügen",
      changePointCloud: "Punktwolke wechseln",
      noPointClouds: "Keine Punktwolken :(",
      noPointCloudsSubtitle: "Hier sind keine Punktwolken verfügbar. Das liegt daran dass im Projekt keine Punktwolken hochgeladen worden oder diese nicht zum Labeling vefügbar sind.",
      noClasses: "Keine Labeling-Klassen :(",
      noClassesSubtitle: "Hier sind keine Klassen zum labeln verfügbar. Das liegt daran, dass diesem Projekt noch keine Klassen zugeordnet wurden.",
      loadingData: "Daten werden geladen...",
      addCellLine1: "Die Zellenauswahl ist aktiv: Wählen Sie eine interessante Zelle aus",
      stopAddingCells: "Beenden",
      addCellLine2: "",
      prelabelClassIds: "Prelabeling",
      dialog: {
        confirmButton: "OK",
        cancelButton: "Abbrechen",
        deleteButton: "Löschen",
        saveButton: "Speichern",
        errorTitle: "Fehler",
        warningTitle: "Warnung",
        successTitle: "Erfolg",
        confirmTitle: "Bestätigung",
        deleteCellTitle: "Zelle löschen",
        deleteCellMessage: "{{cellName}} und ALLE Labels in der Zelle löschen?",
        changeCellDimensionsTitle: "Zellenabmessungen ändern",
        changeCellDimensionsMessage: "Die Abmessungen von {{cellName}} ändern? Bestehende Labels werden nicht verändert.",
        changeCellDimensionsErrorMessage: "Die Zellenabmessungen konnten nicht gespeichert werden.",
        noCellSelectedTitle: "Keine Zelle ausgewählt",
        noCellSelectedMessage: "Bitte wählen Sie zuerst eine Zelle aus, um schwebende Beschriftungen zu importieren.",
        noFloatingLabelsTitle: "Keine schwebenden Beschriftungen",
        noFloatingLabelsMessage: "Keine Beschriftungen ohne Zellenzuordnung gefunden.",
        cellErrorTitle: "Zellenfehler",
        cellErrorMessage: "Die ausgewählte Zelle hat keine ID. Labels können nicht importiert werden.",
        systemErrorTitle: "Systemfehler",
        bboxHandlerErrorMessage: "Begrenzungsrahmen-Handler nicht initialisiert.",
        pointCloudErrorMessage: "Punktwolken-Handler nicht verfügbar.",
        pointCloudLoadErrorMessage: "Die Punktwolke konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
        importFloatingLabelsTitle: "Import abgeschlossen",
        importFloatingLabelsSummary: "{{importedCount}} von {{totalCount}} schwebenden Labels importiert.",
        importFloatingLabelsImportedSection: "Importiert:",
        importFloatingLabelsSkippedSection: "Übersprungen:",
        importFloatingLabelsFailedSection: "Fehlgeschlagen:",
        importFloatingLabelsNoPointsReason: "Keine Punkte für das Label gefunden",
        importFloatingLabelsNoOverlapReason: "Keine Überlappung mit der ausgewählten Zelle",
        importFloatingLabelsObbFailedReason: "Oriented Bounding Box konnte nicht berechnet werden",
        importFloatingLabelsUnknownErrorReason: "Unbekannter Fehler",
      },
      instanceOverview: "Instanzübersicht",
      updating: "Speichern...",
      cellOverview: "Zellenübersicht",
      cellAddition: {
        title: "Zellen manuell hinzufügen",
        manual: "Zellen aus GeoJSON importieren",
        titleManual: "Zellen aus GeoJSON importieren",
      },
      cellDimensions: {
        title: "Zellenabmessungen bearbeiten",
        description: "Ziehen Sie die Griffe der Zellbox in der Szene, um sie anzupassen.",
        apply: "Übernehmen",
        cancel: "Abbrechen",
      },
      cellImport: {
        title: "Zellen importieren",
        dropzoneTitle: "GeoJSON-Datei hier ablegen",
        dropzoneSubtitle: "oder klicken um eine Datei auszuwählen (.geojson / .json)",
        totalFeatures: "Gesamtanzahl Features",
        pointFeatures: "Punkt-Features",
        polygonFeatures: "Polygon-Features",
        cellsToCreate: "Zu importierenfde Rasterzellen",
        overlappingCells: "Überlappung mit vorhandenen Zellen",
        allOverlappingWarning: "Alle Rasterzellen überlappen vorhandene Zellen – nichts zu importieren.",
        allNoZWarning: "In keiner Rasterzelle wurden Punktwolkendaten gefunden – nichts zu importieren. Koordinatensystem prüfen!",
        allBlockedMixedWarning: "Alle Rasterzellen überlappen vorhandene Zellen oder enthalten keine Punktwolkendaten.",
        importResultTitle: "Import abgeschlossen",
        importResultSuccess: "{{count}} Zelle(n) erfolgreich importiert.",
        importResultPartial: "{{imported}} Zelle(n) importiert, {{failed}} fehlgeschlagen.",
        noZWarning: "Keine Z-Koordinaten gefunden – Höhe wird aus bestehenden Zellen geschätzt.",
        noPolygonsWarning: "Keine Polygon-Features gefunden. Nur Polygone werden in Zellen umgewandelt.",
        invalidFile: "Ungültige oder nicht unterstützte GeoJSON-Datei.",
        confirmImport: "{{count}} Zelle(n) importieren",
        selectDifferentFile: "Andere Datei auswählen",
        cancel: "Abbrechen",
      },
      grid: {
        cellTitle: "Zelle {{name}}",
        advanced: "Erweitert",
        unsaved: "Ungespeichert",
        comment: "Kommentar",
        classFilter: "Klassenfilter",
        cellAction: "Zellenaktion",
        unsavedChangesConfirm: "Sie haben ungespeicherte Änderungen. Ohne Speichern verlassen?",
        unsavedChangesTooltip: "Ungespeicherte Änderungen – erst speichern oder verwerfen",
        previousCell: "Vorherige Zelle",
        nextCell: "Nächste Zelle",
        cellCommentPlaceholder: "Zellenkommentar…",
        importFloatingLabels: "Labels ohne Zellzuordnung importieren",
        deleteCell: "Zelle löschen",
        editCellDimensions: "Zellenabmessungen bearbeiten",
        boundingBoxes: "Bounding Boxes",
        showBoundingBoxes: "Bounding Boxes anzeigen",
      },
      gridTab: {
        filter: "Filter",
        status: "Status",
        statusOpen: "Offen",
        statusClosed: "Geschlossen",
        statusConfirmed: "Bestätigt",
        activeFilters: "{{count}} aktiv",
        classFilter: "Klassenfilter",
        options: "Optionen",
        colorPointCloud: "Punktwolke färben",
        cellCount: "{{visible}} / {{total}} Zellen",
        noCellsSaved: "Noch keine Zellen gespeichert. Zuerst Zellen importieren oder manuell anlegen.",
        labelsNotLoadedYet: "Labels noch nicht geladen.",
        prelabeling: "Pre-labeling-Zuordnung",
        managePrelabeling: "Pre-labeling verwalten",
        experimental: "Experimentell",
      },
      prelabeling: {
        subtitle: "Punktwolken-Klassifizierungsnummern auf semantische Klassen abbilden.",
        classCol: "Klasse",
        idsCol: "Klassifizierungs-IDs",
        idsTooltip: "Punktwolken-Klassifizierungsnummern, die dieser Klasse zugeordnet werden",
        invalidIds: "Nur positive, kommagetrennte Ganzzahlen",
        activate: "Zuordnung aktivieren",
        deactivate: "Zuordnung deaktivieren",
        activeSummary: "{{count}} von {{total}} Klassen aktiv",
        noClasses: "Klassen noch nicht geladen.",
      },
      toolbar: {
        points: "Punkte",
        kPoints: "{{value}}k Punkte",
        coloring: "Einfärbung",
        label: "Label",
        classification: "Klassifizierung",
        highlight: "Hervorhebung",
        legend: "Legende",
        reset: "Zurücksetzen",
        pointSize: "Punktgröße",
        projection: "Projektion",
        orthographicCamera: "Orthografische Kamera",
        perspectiveCamera: "Perspektivische Kamera",
        orthographicOrbitOnly: "Erdmodus ist in orthografischer Projektion nicht verfügbar",
        camera: "Kamera",
        background: "Hintergrund",
        gradientBackground: "Gradient als Hintergrund",
        whiteBackground: "Weiß als Hintergrund",
        skyboxBackground: "Horizont als Hintergrund",
      },
      selected: {
        unselect: "Auswahl aufheben",
        previous: "Vorherige",
        first: "Erste",
        focus: "Fokussieren",
        edit: "Bearbeiten",
        next: "Nächste",
        last: "Letzte",
      },
      hotkeys: {
        classPicker: "Drücken Sie die angezeigte Klassentaste, um eine Klasse zu wählen.",
        gridReview: "Leertaste - Label hinzufügen\nLinks/Rechts - Vorheriges/Nächstes Label",
        labelEditing: "Leertaste - Schnitt hinzufügen\nS - Speichern\nEsc - Zurück (nach dem Speichern)",
      },
      pointCloud: {
        labelCount: "{{count}} Label",
        labelCount_plural: "{{count}} Labels",
      },
      cell: {
        size: "{{x}} × {{y}} × {{z}}",
        buffer: "Buffer: {{value}}",
        labelCount: "{{count}} Label",
        labelCount_plural: "{{count}} Labels",
        duplicateName: "Duplikat – andere Zelle mit selbem Namen",
      },
      // Anzeigenamen der AIObjectClass, mit dem ascii nameKey der Klasse als Schlüssel
      classNames: {
        surface_soil: "Oberfläche/Boden",
        vegetation_low: "Vegetation - Niedrig",
        vegetation_medium: "Vegetation - Mittel",
        vegetation_high: "Vegetation - Hoch",
        building: "Gebäude",
        noise_high: "Rauschen (Hoch)",
        noise_vehicle: "Rauschen (Fahrzeug)",
        motor_bicycle: "Motorrad/Fahrrad",
        bus_truck: "Bus/Lkw",
        car: "Auto",
        bar_structure: "Stabbauwerk",
        person_single: "Person (Einzeln)",
        noise_people: "Rauschen (Personen)",
        wall_fence: "Mauer/Zaun",
        structure: "Bauwerk",
        exclude: "Ausschließen",
        wire: "Draht",
        signal_sperrsignal: "Signal - Sperrsignal",
        signal_hv_haupt: "Signal - H/V Haupt",
        signal_hv_vor: "Signal - H/V Vor",
        pzb_magnet: "PZB-Magnet",
        lst_sonstige: "LST sonstige",
        mast_sonstige: "Mast - sonstige",
        mast_ola: "Mast - Oberleitung",
        mast_signal: "Mast - Signal",
        schiene: "Schiene",
        gleisbett: "Gleisbett",
        laermschutzwand: "Lärmschutzwand",
        ueberfuehrung: "Überführung",
        rollmaterial: "Rollmaterial",
        signal_ks: "Signal - Ks",
        sperrmaennchen: "Sperrmännchen",
        ola_structure: "Oberleitungsstruktur",
        signal_structure: "Signalstruktur",
        signalbruecke: "Signalbrücke",
        signal_fragment: "Signalfragment",
        x_an_signal: "X an Signal",
        bahnsteig: "Bahnsteig",
        zwergsignal: "Zwergsignal",
        vegetation_hoch: "Vegetation (Hoch)",
        gebaeude: "Gebäude",
        noise: "Rauschen",
        vegetation_mittel: "Vegetation (Mittel)",
        vegetation_niedrig: "Vegetation (Niedrig)",
        verbotsschild: "Verbotsschild",
        bauwerk: "Bauwerk",
        stabbauwerk: "Stabbauwerk",
      },
    },

    lrp: {
      resumeSurvey: {
        title: "Möchten Sie die Bearbeitung der letzten Befahrung fortsetzen?",
        openLastSurvey: "Letzte Befahrung öffnen",
        goToMap: "Zur Karte",
        error: "Die letzte Befahrung konnte nicht geöffnet werden. Bitte versuchen Sie es erneut oder gehen Sie zur Karte.",
      },
      baseMap: {
        selectedTrackPoint: "Gewählter Gleispunkt"
      },
      menuBar: {
        object: 'Objekte',
        minProfile: 'Minimumprofile',
        trackGeo: 'Gleisgeometrie',
        search: 'Suche',
        searchFor: 'Suchen nach...',
        results: 'Ergebnisse',
        trajectories: 'Befahrungen',
        lrpoExport: 'LRPO-Export',
        traversedGtgStrands: 'GTG-Strängen',
        traversedDfaLines: 'DfA-Linien',
        kmAndDfaValue: 'Kilometer und DfA-Linie',
        swlObjects: 'Objekten',
        gtgStrands: 'GTG-Strängen',
        linePosition: 'Kilometer',
        jumpToObject: "Zum Objekt springen",
        showPopUp: "Bearbeitung-Popup anzeigen",
        showProfile: "Querprofil anzeigen",
        visible: "Eingeblendet",
        nonVisible: "Nicht eingeblendet",
        trackAxis: "Ist-Gleisachsen",
        railHeads: "Schienenköpfe",
        contactWires: "Fahrleitungen",
        runsDdInfo: "Dieses Menü zeigt alle verfügbaren Befahrungen.",
        swlDdInfo: "Dieses Menü zeigt alle verfügbaren Objekte und Kollisionen in dieser Befahrung.",
        minProfileDdInfo: "Dieses Menü zeigt alle verfügbaren Minimumprofile in dieser Befahrung.",
        trackGeoDdInfo: "Über dieses Menü können alle aus der Punktwolke abgeleiteten Gleisgeometrien angezeigt werden.",
      },
      filters: {
        filter: "Filter",
        filterByName: "Filter nach Name",
        filtersByDFA: "Filter nach DfA-Linie",
        filterByKMRange: "Filter nach Kilometerbereich",
        minKm: "Min. Kilometer",
        maxKm: "Max. Kilometer",
        kmRangeRequiresUniqueDfa: "Die Filterung nach Kilometerbereich erfordert eine eindeutige DfA-Linie. Bitte wählen Sie zuerst eine DfA-Linie aus, um den Kilometerbereich-Filter zu aktivieren.",

      },
      mb: {
        loading: "Lade...",
        prev_swl: "Vorheriges Objekt (Q)",
        next_swl: "Nächstes Objekt (W)",
        show_popup: "Infofenster anzeigen (I)",
        show_profile: "Querprofil anzeigen (P)",
        create_swl: "Neues Objekt erstellen (O)",
        deleteSelectedObjects: "Ausgewählte Objekte löschen",
        delete: "Löschen",
        deleteSelectedObjectsConfirm: "Möchten Sie die ausgewählten Objekte wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        deleteSelectedObjectsConfirm: "Achtung: Sie haben Objekte (Anzahl: {{count}})  zum Löschen ausgewählt. Gelöschte Objekte sind nicht mehr im Clearance Inspector sichtbar. Die Aktion kann nicht rückgängig gemacht werden.",
        deleteSelectedObjectsCannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden.",
        deleteConfirmation: "Mir ist bewusst, dass diese Handlung nicht rückgängig gemacht werden kann.",
        deleteSelectedObjectsWarning: "Sie können nicht mehr als 1000 Objekte auf einmal löschen. Bitte teilen Sie den Löschvorgang in mehrere Löschvorgänge auf."
      },
      status: {
        all: 'Alle',
        open: 'Offen',
        closed: 'Geschlossen',
        editing: 'Bearbeitung',
        exported: 'Exportiert',
        discarded: 'Verworfen',
        filterByName: 'Nach Namen filtern',
        status: 'Status',
        completeProcessing: 'Bearbeitung abschließen'
      },
      loadingTrajectories: "Lade Befahrungen...",
      loadingSwlObjects: "Lade Objekte...",
      changeStatusDialog: 'Möchten Sie dieses Objekt wirklich schließen?',
      discardSwlObject: "Möchten Sie dieses Objekt unwiderruflich verwerfen?",
      open: "Öffnen",
      trajectory: 'Befahrung',
      processing: 'Prozessierung',
      objectDeleted: "Objekt gelöscht.",
      popup: {
        attr: {
          type: "Art",
          coordinates: "Punkte",  // Referenzpunkt
          position: "Position",
          description: "Objekt-Nr",  // Objektnummer
          remark: "Bemerkung",
          siopB: "SIOP B",
          trackData: "Ueh / Rad",  // Überhöhung / Radius
          measureDate: "Datum",
          distanceNeighbor: "Gleis li / re",  // Gleisabstand links / rechts
          createdManually: "Erfassung",
          swlId: "Objekt-ID",
        },
        multipleGtgStrandsFound: 'Mehrere GTG-Stränge gefunden!',
        remove_coord: "Koordinate entfernen",
        add_coord: "Neue Koordinate hinzufügen",
        confirm_coords: "Koordinatenänderungen bestätigen",
        discard_changes: "Änderungen verwerfen",
        save_changes: "Änderungen speichern",
        close_popup: "Fenster schließen",
        edit: "Bearbeiten",
        manually: "Manuell",
        automatically: "Automatisch",
        minPoints: 'Min. Punkte',
        maxPoints: 'Max. Punkte',
        pointsToAdd: 'Punkte zu wenig',
        pointsToRemove: 'Punkte zu viel',
        cancel: 'Abbrechen',
        export_pdf: 'PDF exportieren',
        discard: "Objekt verwerfen",
      },
      swl: {
        flMast: "Mast",
        miscMast: "Mast individuell",
        noiseBarrier: "LSW",
        p35: "P35",
        p55: "P55",
        auxiliaryP55: "Hilfstritt",
        miscPlatformEdge: "Perronkante",
        dwarfLargeRight: "Zwerg gross richtig",
        dwarfLargeWrong: "Zwerg gross falsch",
        dwarfSmallRight: "Zwerg klein richtig",
        dwarfSmallWrong: "Zwerg klein falsch",
        dwarfEtcsRight: "Zwerg ETCS richtig",
        dwarfEtcsWrong: "Zwerg ETCS falsch",
        overpassShort: "Überführung kurz",
        overpassLong: "Überführung lang",
        signalBasketOld: "Signalkorb alt",
        prohibitionSign: "Verbotstafel",
        unknown: "Unbekannt",
        misc: "Sonstiges Objekt",
        tunnel: "Tunnel",
        abfahrbefehl: "Abfahrbefehl",
        abhang: "Abhang",
        abspannung: "Abspannung",
        absperrung: "Absperrung",
        abstellsektorentafel: "Abstellsektorentafel",
        absturzsicherung: "Absturzsicherung",
        ankuendigungslampe: "Ankündigungslampe",
        aufhaengung: "Aufhängung",
        aufhaengungIndividuell: "Aufhängung individuell",
        barrierenStock: "Barrieren-Stock",
        beleuchtung: "Beleuchtung",
        betonaufsatzIndividuell: "Betonaufsatz individuell",
        betondecke: "Betondecke",
        betonpfeilerIndividuell: "Betonpfeiler individuell",
        betontraeger: "Betonträger",
        boeschung: "Böschung",
        brueckenpfeiler: "Brückenpfeiler",
        brueckentraeger: "Brückenträger",
        buegel: "Bügel",
        buegelsenklichtsignal: "Bügelsenklichtsignal",
        buegelsenksignal: "Bügelsenksignal",
        buegelsenksignalBreit: "Bügelsenksignal breit",
        buegelsenksignalSchmal: "Bügelsenksignal schmal",
        dach: "Dach",
        dachIndividuell: "Dach individuell",
        dachablauf: "Dachablauf",
        dachrinne: "Dachrinne",
        dachstuetze: "Dachstütze",
        dienstweg: "Dienstweg",
        dienstwegLf: "Dienstweg Lf",
        dreiecksaufsatz: "Dreiecksaufsatz",
        dreiecktafel: "Dreiecktafel",
        eisenbruecke: "Eisenbrücke",
        elektrokasten: "Elektrokasten",
        erdungsstangenfach: "Erdungsstangenfach",
        etcsTafel: "ETCS Tafel",
        fahrdraht: "Fahrdraht",
        fahrtstellungsmelder: "Fahrtstellungsmelder",
        fia: "FIA",
        fundament: "Fundament",
        gelaender: "Geländer",
        geschwSignal: "Geschw. Signal",
        gewichteFuerAbspannung: "Gewichte für Abspannung",
        halade: "Halade",
        halterung: "Halterung",
        haltestellenTafel: "Haltestellen-Tafel",
        handrad: "Handrad",
        handschalter: "Handschalter",
        hektometertafel: "Hektometertafel",
        hemmschuhhalter: "Hemmschuhhalter",
        hydrant: "Hydrant",
        kabelkanal: "Kabelkanal",
        kabelschiene: "Kabelschiene",
        kabelverteiler: "Kabelverteiler",
        kamera: "Kamera",
        karrenuebergang: "Karrenübergang",
        lautsprecher: "Lautsprecher",
        leiter: "Leiter",
        leiterbuegel: "Leiterbügel",
        leiterhalterung: "Leiterhalterung",
        leitplanke: "Leitplanke",
        lichtschranke: "Lichtschranke",
        mastFussplatte: "Mast Fussplatte",
        mauer: "Mauer",
        mauer120Plus: "Mauer 120 Plus",
        mauerIndividuell: "Mauer individuell",
        melder: "Melder",
        nachbargleis: "Nachbargleis",
        notausstieg: "Notausstieg",
        notfallschieber: "Notfallschieber",
        passarelle: "Passarelle",
        perronIndividuell: "Perron individuell",
        perrondach: "Perrondach",
        pfosten: "Pfosten",
        podest: "Podest",
        podestIndividuell: "Podest individuell",
        prellbock: "Prellbock",
        railsafe: "Railsafe",
        rampe: "Rampe",
        rampeIndividuell: "Rampe individuell",
        rampeSchraeg: "Rampe schräg",
        rangierhaus: "Rangierhaus",
        rangiersignal: "Rangiersignal",
        rohr: "Rohr",
        schacht: "Schacht",
        schotterspriessung: "Schotterspriessung",
        schutzgeruest: "Schutzgerüst",
        schutzgitter: "Schutzgitter",
        schutzNische: "Schutz-Nische",
        schutztrennung: "Schutztrennung",
        sicherheitsbuegel: "Sicherheitsbügel",
        siemens: "Siemens",
        signalAlt: "Signal alt",
        signalIndividuell: "Signal individuell",
        signalNeu: "Signal neu",
        signalBedarfshalt: "Signal-Bedarfshalt",
        signalkorbNeu: "Signalkorb neu",
        stahlstuetzenfussKonisch: "Stahlstützenfuss konisch",
        signaltafelRund: "Signaltafel rund",
        standhoehe: "Standhöhe",
        stromanschluss: "Stromanschluss",
        tafelGross: "Tafel gross",
        tafelKlein: "Tafel klein",
        thalesAlcatelKasten: "Thales/Alcatel-Kasten",
        traeger: "Träger",
        treppe: "Treppe",
        ueberfuehrungkurz: "Überführung kurz",
        ueberwerfung: "Überwerfung",
        uhr: "Uhr",
        unterfuehrung: "Unterführung",
        verbotstafelTypC: "Verbotstafel Typ C",
        versicherungsbolzen: "Versicherungsbolzen",
        wasseranschluss: "Wasseranschluss",
        weichenbild: "Weichenbild",
        weichenlaterne: "Weichenlaterne",
        weichenlichtsignal: "Weichenlichtsignal",
        weichenstellbock: "Weichenstellbock",
        wetterstation: "Wetterstation",
        zaun: "Zaun",
        zeitwEinbau: "Zeitw Einbau",
        zugsvorheizung: "Zugsvorheizung",
        zwergEtcsTafelFalsch: "Zwerg ETCS Tafel falsch",
        zwergEtcsTafelRichtig: "Zwerg ETCS Tafel richtig",
        zwergMitDreieckaufsatz: "Zwerg mit Dreieckaufsatz"
      },
      minProfile: {
        name: "Minimumprofil",
        loadingMinProfiles: "Lade Minimumprofile...",
        downloadDialogTitle: 'Sind Sie sicher, dass Sie die Datei herunterladen möchten?',
        approve: "Herunterladen",
      },
      singleProfile: {
        name: "Eizelprofil"
      },
      profileInfo: {
        measurement: "Messungen",
        startMeasurement: "Messung starten (L)",
        stopMeasurement: "Messung beenden",
        showProfile: "Profil anzeigen (P)",
        createObject: "Objekt erstellen (O)",
        clearMeasurement: "Messung löschen",
        profileSize: "Profildicke",
        placedCoordinate: "Platzierte Koordinate",
        legend: {
          legend: "Legende",
          export: "Export",
          infos: "Infos",
          roi: "Region Of Interest, dessen Ursprung die Gleisachse des befahrenen Gleises ist.",
          schienenkoepfe: "Erkannte Schienenköpfe des Gleises auf welches sich das Objekt bezieht.",
          gleisachse: "Erkannte Gleisachse des Gleises auf welches sich das Objekt bezieht. Bezug für den dx Abstand."
        }
      },
      pointCloudInfo: {
        appearance: "Darstellung",
        opacity: "PW-Deckkraft",
        changeMode: "Modus wechseln",
        panorama: "Panorama",
        trajectory: "Trajektorie",
        pointCloud: "Punktwolke",
        trajectoryMode: "Trajektorienmodus",
        navigateForward: "Vorwärts navigieren (.)",
        navigateBackward: "Rückwärts navigieren (,)",
        panoramaMode: "Panoramamodus",
        toPanoramaMode: "Zum Panoramamodus",
        toTrajectoryMode: "Zum Trajektorienmodus",
        showReferencePoints: "Referenzpunkte anzeigen",
        showBbox: "Bounding Box anzeigen",
        labels: "Labels",
      },
      infoContainer: {
        mapRun: "MAP",
        mapOverview: "MAP",
        sceneRun: "3D",
        profileRun: "PRF",
        minimizeMap: "Karte minimieren",
        normalMap: "Normale Karte",
        rotateLeft: "Links drehen (X)",
        rotateRight: "Rechts drehen (Y)"
      }
    },
    pricing: {
      mainTitle: 'X2BIM Preise',
      included: 'Enthalten',
      additionalUser: 'Zusätzliche Benutzer:innen',
      includedCredits: 'Kunde erhält bei Bestellung (einmalig)',
      creditCost: 'Kreditkosten',
      inclProcessAndHosting: '',
      concurrProcessPipelines: 'Gleichzeitige Verarbeitungspipelines',
      tierButton: 'Loslegen',
      tier: 'Paket',
      credits: 'Credits',
      'Order Access': 'Bestellzugang',
      'Tools': 'Werkzeuge',
      'Updates': 'Aktualisierungen',
      'Support': 'Unterstützung',
      'Unlimited Projects': 'Unbegrenzte Projekte',
      'SSO': 'Single Sign On',
      'Unlimited Users*': 'Unbegrenzte Benutzer:innen*',
      '5 registrierte Nutzer': '5 registrierte Nutzer',
      '30 registrierte Nutzer': '30 registrierte Nutzer',
      "User Management": "Benutzerverwaltung",
      "CAD, GIS and BIM Integration": "CAD-, GIS- und BIM-Integration",
      "Achsenwerkzeuge": "Achsenwerkzeuge",
      "Nutzersupport": "Nutzersupport",
      "Premium support​": "Premium Support​",
      table: {
        title: 'Credits',
        subTitle: "Credits sind die plattforminterne Einheit zur Verrechnung einzelner Datenprozessierungsschritte, sowie für den Speicherbedarf.",
        header: ['Position', 'Beschreibung', 'Einheit', 'Credits pro Einheit'],
        content: [
          { position: '1', description: 'UAV/Befliegungsdaten', unit: '1 GigaPixel (Gpix)', creditsPerUnit: '1000' },
          { position: '2', description: 'Punktwolken (inkl. Panoramabilder)', unit: '1 Gigabyte (GB)', creditsPerUnit: '200' },
          { position: '3', description: 'allg. Speicherkosten (pro Monat)', unit: '1 Gigabyte (GB)', creditsPerUnit: '5' },
          // { position: '4', description: 'KI/Objekterkennung *', unit: '-', creditsPerUnit: '-' },
          { position: '4', description: 'Planimport (Geotiff, DXF)', unit: 'pro Prozess', creditsPerUnit: '250' },
          { position: '5', description: 'IFC-Modell', unit: 'pro Prozess', creditsPerUnit: '250' },
          { position: '6', description: 'Einrichtung Single-Sign On Setup*', unit: 'einmalig', creditsPerUnit: '-' },
        ],
        note: 'Hinweis: *Nur in Kombination mit Advanced oder Enterprise Tier verfügbar',
      },
      calculator: {
        title: 'Kalkulationshilfe für Ihre Projekte',
        subTitle: 'Im folgenden finden Sie eine Ausfüllhilfe für die prognostizierten Kosten.',
        selectATier: 'Wählen Sie ein Paket aus:',
        tiers: ['Basic', 'Advanced', 'Enterprise'],
        noFlightsPerMonth: 'Anzahl der Flüge / Monat',
        noPhotosPerFlight: 'Anzahl der Fotos / Flug',
        creditsIncluded: 'Credits im {{tier}}',
        megapixels: 'Megapixel',
        creditsPerMonth: 'Credits einmalig bei Vertragsabschluss',
        extraCreditsPerMonth: 'Zusätzliche Credits pro Monat erforderlich:',
        calculationHelper: 'Eingangsdaten',
        imageProcessing: {
          title: 'Berechnen Sie die Gigapixel für Ihre monatlichen Flüge.',
          knownDataQuestion: "Ist die ⌀ monatliche Menge an Befliegungsdaten (UAV) in Gigapixel bekannt?",
          dataAmountInGigapixels: "* Datenmenge in Gigapixel",
          gigapixelCalculator: "Gigapixel Rechner",
          externalOrthophotosQuestion: "Haben Sie externe Orthobilder (bsp. Helikopterdaten)?",
          pointCloudDataKnownQuestion: "Haben Sie externe Punktwolken (bsp. terrestrische Laserscanner)?",
          pointCloudDataKnownQuestionSize: "Abschätzung der Größe von Punktwolken:",
          dxfPlanVolume: " *DXF Datei(en)",
          dxfPlanDataKnownQuestion: "Haben Sie CAD-Pläne (DXF) zur Integration in X2BIM?",
          ifcModelsQuantityKnownQuestion: "Haben Sie BIM-Modelle (IFC) zur Integration in X2BIM?",
          pointCloudDataKnownQuestionPointSize: "Abschätzung der Größe von Punktwolken:",
          storageInMonthsQuestion: "Geschätzte Dauer der Datenspeicherung in Monaten?",
          numberOfUsersQuestion: "Anzahl Benutzer:innen",
          singleSignOnSetupQuestion: "Single Sign-on Setup (Nur verfügbar für Advanced und Enterprise)",
          singleSignOnSetupCost: "Einrichtung Single-SignOn Setup kostet einmalig 5000 Euro, inklusive eigener kundenspezifischer Subdomain (u.a. htttps://kundenname.x2bim.com)"

        },
        storage: {
          title: 'Berechnen Sie die zusätzlichen monatlichen Credits für Ihre Speicheranforderungen.',
          numberOfUsersQuestion: "Anzahl Benutzer:innen",
          storageInMonthsQuestion: "Geschätzte Dauer der Datenspeicherung in Monaten?",
          storageInMonthsQuestionHint: "Der Speicherbedarf in Credits ergibt sich aus einer angenommenen linearen Verteilung der verarbeiteten Daten und stellt nur eine grobe Schätzung dar."
        },
        userAccess: {
          singleSignOnSetupQuestion: 'Berechnen Sie die zusätzlichen monatlichen Credits für Ihre Benutzeranforderungen.',
          numberOfUsersQuestion: "Anzahl Benutzer:innen:",
        },
        pointCloudProcessing: {
          title: 'Berechnen Sie die zusätzlichen monatlichen Credits für Ihre Punktwolkenverarbeitungsanforderungen.',
        },
        yourCosts: 'Zusammenfassung (monatlichen Credits)',
        result: {
          totalFlights: 'Menge an Befliegungsdaten (UAV)',
          externalOrthophotos: 'Externe Orthobilder (bsp. Helikopterdaten)',
          externalPointClouds: "Externe Punktwolken (bsp. terrestrische Laserscanner)",
          cadPlans: "CAD-Pläne (DXF) zur Integration in X2BIM",
          bimModels: "BIM-Modelle (IFC) zur Integration in X2BIM",
          dataStorageDuration: "Speicherkosten (geschätzt)",
          numberOfUsers: "Anzahl Benutzer:innen",
          pointCloudProcessingCosts: "Gesamtcredits",
          singleSignOnSetup: "Single Sign-on Setup",
        },
        description: "Beschreibung",
        priceIndication: "Preisindikation*",
        month: "Monat",
        total: "Gesamt",
        ssoExclusion: "* Einrichtung von Single Sign-on ist hiervon ausgenommen und wird seperat verrechnet.",
        secondMonthOnwardsDetails: "** Preisindikation unter Annahme, dass Credits aus Einmalguthaben direkt verbraucht wurden.",
        firstMonth: "1. Monat",
        secondMonthOnwards: "Ab 2. Monat**"
      }
    },

    // BIM Viewer
    bim: {
      ifcInstruction: "IFC | Umschalt+Click für Mehrfachauswahl",
      reset: "Zurücksetzen",
      isolate: "Isolieren",
      hide: "Ausblenden",
      inspect: "Inspect",
      compare: "Compare",
      collab: "BIMCollab",
      issues: "Issuemanagment",
      measurement: "Messen",
      layerManagement: "Ebenenverwaltung",
      layerManagementDropHere: "Ebene hierher ziehen",
      layerOpacity: "Deckkraft",

      // ACC File Browser
      acc: {
        title: "ACC Datei Import",
        login: "ACC Anmeldung",
        loggedIn: "Erfolgreich mit Ihrem Autodesk-Konto verbunden.",
        connectToACC: "Verbindung mit Autodesk Construction Cloud (ACC)",
        pleaseLogin: "Bitte melden Sie sich an, um Ihre ACC Hubs und Projekte zu durchsuchen.",
        loginWithAutodesk: "Mit Autodesk anmelden",
        checkingStatus: "Status wird geprüft...",
        authenticationError: "Authentifizierungsfehler",
        selectHub: "Hub auswählen",
        selectHubTitle: "Autodesk Hub auswählen",
        selectProject: "Projekt auswählen in",
        selectProjectTitle: "ACC Projekt auswählen",
        back: "Zurück",
        up: "Hoch",
        noHubsFound: "Keine Hubs gefunden.",
        noProjectsFound: "Keine Projekte gefunden.",
        folderEmpty: "Dieser Ordner ist leer.",
        import: "Import",
        logoutFromACC: "Von ACC abmelden",
        confirmImport: "Datei-Import bestätigen",
        confirmImportText: "Sie sind dabei, den Import von",
        confirmImportDetails: "aus",
        confirmImportNote: " zu starten. Die Datei wird von unserem Server über eine signierte URL heruntergeladen, durch die IFC-Kette verarbeitet und anschließend in die Plattform importiert. Dabei fallen Credits an.",
        cancel: "Abbrechen",
        confirmImportButton: "Import bestätigen",
        importInitiated: "Import für *{{fileName}}* eingeleitet! Sie werden benachrichtigt, wenn die Verarbeitung abgeschlossen ist.",
        importFailed: "Import für *{{fileName}}* konnte nicht gestartet werden.",
        importError: "Importfehler: {{error}}",
        sessionExpired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
        hubFetchFailed: "Fehler beim Abrufen der ACC Hubs.",
        projectFetchFailed: "Fehler beim Abrufen der Projekte für den ausgewählten Hub.",
        fileStatus: {
          notImported: "Nicht importiert",
          upToDate: "Aktuell",
          outdated: "Veraltet"
        }
      },

      // BIM Collaboration
      bimcollab: {
        login: "Anmelden",
        successfullyLoggedIn: "Erfolgreich angemeldet.",
        updateInformation: "Informationen aktualisieren",
        logout: "Abmelden",
        logoutFromBimCollab: "Von BIMCollab abmelden",
        pleaseConnect: "Bitte verbinden Sie sich mit BIMCollab, um Ihre Projekte und Issues zu durchsuchen.",
        connectToBimCollab: "Verbindung mit BIMCollab",
        loginWithBimCollab: "Mit BIMCollab anmelden",
        projectInformation: "Projektinformationen",
        projectName: "Projektname",
        noProjectInfo: "Keine Projektinformationen verfügbar",
        topics: "Topics",
        noTopicsAvailable: "Keine Topics verfügbar",
        newIssue: "Neues Issue",
        createNewIssueText: "Erstellen Sie ein neues Issue in diesem Projekt.",
        createNewIssue: "Neues Issue erstellen",
        createIssue: "Issue erstellen",
        saveChanges: "Änderungen speichern",
        title: "Titel",
        status: "Status",
        type: "Typ",
        priority: "Priorität",
        description: "Beschreibung",
        assignedTo: "Zugewiesen an (E-Mail)",
        dueDate: "Fälligkeitsdatum",
        topicMetadata: "Themen-Metadaten",
        createdBy: "Erstellt von",
        createdDate: "Erstellungsdatum",
        modifiedBy: "Geändert von",
        modifiedDate: "Änderungsdatum",
        labels: "Beschriftungen",
        comments: "Kommentare",
        addComment: "Kommentar hinzufügen...",
        send: "Senden",
        noCommentsYet: "Noch keine Kommentare",
        viewportSnapshot: "Ansichtsfenster-Snapshot",
        viewpointSnapshot: "Viewpoint-Snapshot",
        noSnapshotAvailable: "Kein Snapshot verfügbar",
        captureSnapshot: "Snapshot erfassen",
        retakeSnapshot: "Snapshot erneut aufnehmen",
        additionalViewpoints: "Zusätzliche Viewpoints",
        issue: "Problem",
        tableFilters: "Tabellenfilter",
        availableColumns: "Verfügbare Spalten",
        selectedColumns: "Ausgewählte Spalten",
        add: "Hinzufügen",
        remove: "Entfernen",
        showFilters: "Filter anzeigen",
        edit: "Bearbeiten",
        repositionTooltip: "Sie können ein Element auswählen, um es neu zu positionieren.",
        statusValues: {
          active: "Aktiv",
          open: "Offen",
          inProgress: "In Bearbeitung",
          resolved: "Gelöst",
          closed: "Geschlossen"
        },
        typeValues: {
          issue: "Problem",
          fault: "Fehler",
          clash: "Konflikt",
          request: "Anfrage",
          inquiry: "Anfrage"
        },
        priorityValues: {
          critical: "Kritisch",
          high: "Hoch",
          major: "Wichtig",
          normal: "Normal",
          minor: "Gering",
          low: "Niedrig"
        }
      },

      // BIM Viewer Top Panel
      topPanel: {
        unnamedProject: "Unbenanntes Projekt",
        catalog: "Katalog",
        layerMenu: "Layermenü",
        threeDView: "3D-Ansicht",
        viewerScene: "Viewer-Szene",
        fov: "Sichtfeld",
        small: "klein",
        large: "groß",
        pointCloud: "Punktwolke",
        pointSize: "Punktgröße",
        pointBudget: "Punktbudget",
        low: "niedrig",
        high: "hoch",
        opacity: "Deckkraft",
        bimModels: "BIM-Modelle",
        resetView: "Ansicht zurücksetzen",
        resetAll: "Alles zurücksetzen",
        // Paletten-Menü: Farbschema, 3D-Hintergrund und Textgröße
        appearance: {
          theme: "Farbschema",
          background: "3D-Viewer-Hintergrund",
          textSize: "Textgröße",
          themes: {
            dark: { label: "Dunkler Modus", description: "Standard-Farbschema des BIM-Viewers" },
            highContrastDark: { label: "Hoher Kontrast dunkel", description: "Dunkel mit maximalem Kontrast (WCAG AAA)" },
            highContrastLight: { label: "Hoher Kontrast hell", description: "Hell mit maximaler Lesbarkeit" }
          },
          backgrounds: {
            gradient: { label: "Verlauf", description: "Standard-Hintergrund des BIM-Viewers" },
            black: { label: "Schwarz", description: "Vollständig schwarzer Hintergrund" },
            white: { label: "Weiß", description: "Vollständig heller Hintergrund" }
          },
          textSizes: {
            small: { label: "Klein", description: "Kompakt – 13 px" },
            medium: { label: "Mittel", description: "Standard – 16 px" },
            large: { label: "Groß", description: "Bessere Lesbarkeit – 20 px" }
          }
        }
      },

      // BIM Viewer angeheftete Werkzeuge (Leiste über der unteren Navigationsleiste)
      tools: {
        cameraFrustums: "Kamerastandpunkte",
        cameraFrustumsFocus: "Auf alle Kameras zoomen",
        cameraFrustumImages: "Fotos auf den Kameraebenen anzeigen",
        cameraFrustumCount: "{{count}} Kameras",
        cameraFrustumLoading: "Kameras werden geladen…",
        cameraFrustumNone: "Kein Flug mit Fotos geladen",
        cameraFrustumFlights: "Flüge",
        photoLookupPick: "Fotos zu einem Punkt suchen — Stelle in der Szene anklicken",
        photoLookupCount: "{{count}} Fotos zeigen diesen Punkt",
        photoLookupEmpty: "Kein Foto zeigt diesen Punkt",
        photoLookupHint: "Punkt in der Szene wählen, um zu sehen, welche Fotos ihn zeigen.",
        photoLookupClose: "Schließen",
        cameraViewTitle: "Im Foto · {{name}}",
        cameraViewHint: "Ziehen zum Umsehen. Wegbewegen verlässt diese Ansicht.",
        cameraViewOpacity: "Deckkraft des Fotos",
        cameraViewExit: "Verlassen",
        cameraViewPrevious: "Vorheriges Foto",
        cameraViewNext: "Nächstes Foto",
        panoramaViewTitle: "360° · {{name}}",
        panoramaViewHint: "Ziehen zum Umsehen. Boden anklicken, um zu einem nahen Panorama zu wechseln.",
        panoramaViewExit: "Verlassen",
        panoramaViewPrevious: "Vorheriges Panorama",
        panoramaViewNext: "Nächstes Panorama",
        panoramaViewOpacity: "Deckkraft der Punktwolke",
        panoramaViewColorAdjustments: "Bildanpassung",
        clipScene: "Szene zuschneiden",
        clipDimensions: "Abmessungen",
        clipRotation: "Rotation",
        clipInvert: "Zuschnitt umkehren",
        clipGhostPersistent: "Weggeschnittenen Kontext immer anzeigen",
        clipSlice: "Schnittmodus",
        clipSliceAxis: "Achse",
        clipPosition: "Position",
        clipThickness: "Dicke",
        clipPin: "Panel anheften",
        clipUnpin: "Panel lösen",
        clipFollowCamera: "Kamera folgt Schnitt",
        clipHandles: "Flächen- und Rotationsgriffe",
        clipViewAlong: "Blick entlang {{axis}}",
        clipLinePicking: "Achse in der 3D-Szene anklicken … Esc oder erneuter Klick bricht ab",
        clipLineSelect: "Schnitt entlang einer Achse – klicken und Achse in der 3D-Szene wählen",
        clipLineReady: "Schnitt entlang Achse {{label}} starten",
        clipLineActive: "Schnitt entlang Achse {{label}} – klicken, um eine andere Achse zu wählen",
        clipLineWidth: "Breite",
        clipFitView: "Box an aktuelle Ansicht anpassen",
        clipFitModel: "Box an gesamtes Modell anpassen",
        clipCloseProfile: "Höhenprofil schließen",
        clipOpenProfile: "Höhenprofil öffnen",
        clipOpenProfileUnavailable: "Höhenprofile benötigen einen vertikalen, nicht umgekehrten X- oder Y-Schnitt",
        profileWidth: "Profildicke",
        profileOpenSlice: "Als 3D-Schnitt anzeigen",
        profileOpenSliceUnavailable: "3D-Schnitte benötigen eine geladene Szene",
        clipNudgeHint: "Schrittweite {{step}}.\nMit Umschalt {{fine}}, mit Alt {{coarse}}.\nPfeil gedrückt halten für Wiederholung – je länger, desto schneller.\nOder auf die Zahl klicken, um sie genau einzugeben.",
        clipPrecisionHint: "Regler ziehen für grobe Änderungen.\nUmschalt + Ziehen — fein, 1 m pro Pixel.\nAlt + Ziehen — besonders grob.\nPfeile ändern um eine Stufe; Umschalt ▸ 1 m, Alt ▸ zehn Stufen.\nAuf eine Zahl klicken, um sie genau einzugeben.\nIn der Szene: Ecke ziehen zum Skalieren, Umschalt zum Verschieben, Alt für feines Ziehen."
      },

      // BIM Compare
      compareUI: {
        opacityBlend: "Überblendung",
        model: "Modell",
        selectInfo: "Wählen Sie sowohl ein Ziel als auch eine Referenz aus und aktivieren Sie dann die Vergleichs- und Abweichungsfunktionen.",
        bimModels: "BIM-Modell(e)",
        pointClouds: "Punktwolke(n)",
        selectAll: "Alle auswählen",
        compare: "Vergleichen",
        stopCompare: "Vergleich stoppen",
        selectColors: "Manuell einfärben",
        colorByDeviation: "Einfärben nach Abweichung",
        deviation: "Abweichung",
        deviationDistance: "Abweichungsdistanz",
        absolute: "Absolut",
        signed: "Signiert",
        coloring: "Färbung"
      },

      // IFC Structure
      structure: {
        clickToView: "Klicken Sie auf ein Objekt, um seine Eigenschaften anzuzeigen",
        multiselect: "Mehrfachauswahl: {{count}} Ausgewählt",
        noPropertiesAvailable: "Keine Eigenschaften verfügbar."
      },

      // Window Controls
      window: {
        dockLeft: "Links andocken",
        dockRight: "Rechts andocken",
        undock: "Abdocken",
        hideDock: "Seitenleiste ausblenden",
        showDock: "Seitenleiste einblenden",
        close: "Fenster schließen"
      },

      // Add Data Modal
      addData: {
        title: "Modell oder Punktwolke hinzufügen",
        search: "Suchen",
        showAll: "Alle anzeigen",
        ifcModels: "IFC-Modelle",
        pointclouds: "Punktwolken",
        orthophotos: "Orthofotos",
        plans: "Pläne",
        geoServices: "Geodienste",
        gndLayers: "GIS/GND",
        cadSublayers: "Layer",
        addTo: "Zu {{target}} hinzufügen",
        removeFrom: "Aus {{target}} entfernen",
        gnd2dHeightsHint: "2D-Layer ohne Höhen: die Höhe wird an die Punktwolke angenähert und nur dort angezeigt, wo eine Punktwolke liegt.",
        layoutSwitched: "Ansicht auf 3D + 2D umgestellt",
        undo: "Rückgängig",
        importFromACC: "Aus ACC importieren/aktualisieren",
        monitoringDashboard: "Prozesse im Dashboard ansehen",
        noFilesFound: "Keine Dateien gefunden, die Ihren Kriterien entsprechen.",
        noFilesAvailable: "Es sind keine Dateien verfügbar.",
        autoLoad: "Automatisch im Ausschnitt laden",
        autoLoadHint: "Lädt automatisch alle Ressourcen dieser Kategorie, die den aktuellen Filtern entsprechen und deren Ausdehnung im sichtbaren Kartenausschnitt liegt. Die Auswahl aktualisiert sich beim Verschieben der Karte oder beim Ändern der Filter. Jede Kategorie hat einen eigenen Schalter und lädt nach dem Aktivieren im Hintergrund weiter.",
        processId: "Prozess-ID",
        inMapExtent: "Kartenausschnitt",
        mapExtentTooltip: "Beschränkt die Liste auf Ressourcen, deren Ausdehnung den aktuellen Kartenausschnitt überschneidet.",
        byDataType: "Nach Datentyp",
        bySensorType: "Nach Sensortyp",
        viewerSettings: "Anzeigeeinstellungen",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        ifcNotAutoLoadable: "IFC-Modelle haben keinen Kartenausschnitt und können nicht automatisch geladen werden.",
        showProcessCluster: "Prozesscluster anzeigen",
        dataTypes: "Datentypen",
        mapReference: "Kartenbezug",
        uploadTags: "Upload-Tags",
        autoLoadedGroup: "Automatisch geladen",
        uav: "UAV",
        mobileMapping: "MobileMapping (MSP)",
        liraNextGen: "Lira/NextGen (MSS)",
        catalogTitle: "Katalog",
        allData: "Alle Daten",
        tabOrthos: "Orthos",
        typeOrtho: "Ortho",
        dems: "DOM",
        typeDem: "DOM",
        panoramas: "360°-Bilder",
        typePanorama: "360°",
        helicopter: "Helikopter",
        datasetAdd: "Alle",
        datasetRemove: "Entfernen",
        datasetPartialHint: "{{added}} von {{total}} Teilen hinzugefügt – klicken, um die übrigen hinzuzufügen",
        unavailable: "Nicht verfügbar",
        addFailedRetry: "Konnte nicht geladen werden – klicken, um es erneut zu versuchen",
        typePointcloud: "Punktwolke",
        typeIfc: "IFC-Modell",
        typePlan: "Plan",
        typeGeoservice: "Geodienst",
        typeGnd: "GIS/GND",
        configurations: "Konfigurationen",
        configurationsMock: "Beispielkonfigurationen (Mock) – das Anwenden einer Konfiguration folgt, sobald das Backend verfügbar ist.",
        autoLoadSelect: "Daten automatisch laden?",
        moreActions: "Weitere Aktionen",
        showProcessesInDashboard: "Prozesse im Dashboard anzeigen",
        sortByDate: "Nach Datum sortieren",
        sortByTitle: "Nach Titel sortieren",
        sortByDescription: "Nach Beschreibung sortieren",
        sortReversed: "Reihenfolge umgekehrt",
        searchShort: "Suche",
        inMapExtentChip: "im Kartenausschnitt",
        onlyActive: "nur aktive Ressourcen",
        moreFilters: "Weitere Filter",
        removeAllLayers: "Alle Layer entfernen",
        resourceCount_one: "({{count}} Ressource)",
        resourceCount_other: "({{count}} Ressourcen)",
        noTitle: "Kein Titel",
        noDescription: "Keine Beschreibung",
        noDate: "Kein Datum",
        collapseSidebar: "Seitenleiste einklappen",
        expandSidebar: "Seitenleiste ausklappen",
        addAll: "Alle hinzufügen",
        removeAll: "Alle entfernen",
        zoomTo: "Anzeigen",
        collapse: "Einklappen",
        expand: "Ausklappen",
        filterDate: "Datum:",
        filterTags: "Tags:",
        filterType: "Typ:",
        resetAll: "Alle zurücksetzen",
        selectedSuffix_one: "Ressource ausgewählt",
        selectedSuffix_other: "Ressourcen ausgewählt",
        download: "Herunterladen",
        downloadComingSoon: "Herunterladen ist noch nicht verfügbar.",
        addSelected: "Hinzufügen",
        addedToast_one: "{{count}} Ressource hinzugefügt",
        addedToast_other: "{{count}} Ressourcen hinzugefügt"
      },

      layerMenu: {
        title: "Layermenü",
        search: "Suchen",
        filter: "Filter",
        openCatalog: "Katalog öffnen",
        empty: "Noch keine Layer hinzugefügt:",
        noMatches: "Keine passenden Layer",
        section3d: "3D",
        hide: "Ausblenden",
        show: "Einblenden",
        remove: "Entfernen",
        removeDataset: "Alle Teile entfernen",
        showAll: "Alle Teile einblenden",
        keep: "Layer behalten",
        dragToReorder: "Ziehen, um die Zeichenreihenfolge zu ändern oder in eine andere Karte zu verschieben",
        selectedCount_one: "{{count}} Layer ausgewählt",
        selectedCount_other: "{{count}} Layer ausgewählt",
        display: "Darstellung",
        cadLayers: {
          notLoaded: "Die Layer werden aus der Karte gelesen und erscheinen, sobald die Zeichnung im Kartenausschnitt sichtbar ist.",
          fromView: "Layer aus den bisher angezeigten Kartenausschnitten. Beim Verschieben und Zoomen kommen weitere hinzu."
        },
        toggleList: {
          search: "Suchen",
          noMatches: "Keine Treffer",
          showEmpty_one: "{{count}} ohne Daten anzeigen",
          showEmpty_other: "{{count}} ohne Daten anzeigen",
          hideEmpty: "Ohne Daten ausblenden"
        },
        ifcStyle: {
          surface: "Modell",
          wireframe: "Drahtgitter",
          color: "Farbe",
          grey: "Grau",
          white: "Weiß"
        },
        pointcloudStyle: {
          rgba: "RGB",
          intensity: "Intensität",
          intensityGradient: "Intensität Gradient",
          elevation: "Höhenskala",
          color: "Einfarbig",
          classification: "Farbe nach Klassifizierung",
          gamma: "Gamma",
          brightness: "Helligkeit",
          contrast: "Kontrast",
          elevationRange: "Höhenbereich",
          elevationInterval: "Höhenintervall",
          intervalBase: "Bezugshöhe",
          interval: "Intervall",
          classes: "Klassen",
          classVisibilityHint: "Ein- und Ausblenden gilt für alle Punktwolken",
          pickColor: "Farbe wählen",
          reset: "Zurücksetzen"
        }
      },

      // GLB Root View
      glbRoot: {
        legacyIFC: "Legacy-IFC",
        unnamed: "Unbenannt",
        expandAll: "Alle erweitern",
        collapseAll: "Alle einklappen",
        resetSelection: "Auswahl zurücksetzen ({{count}})",
        model: "Modell {{number}}"
      },

      // Map View
      mapView: {
        miniMapTitle: "2D Karte",
        view3d: "3D Ansicht",
        viewMini: "3D + 2D Mini-Karte",
        viewSplit: "Geteilte Ansicht (3D & 2D)",
        viewTSplit: "T-Layout (3D + 2×2D)",
        viewMap: "2D-Karte",
        viewComparator: "Kartenvergleich",
        syncTitle: "Synchronisation 2D/3D",
        syncPosition: "Bewegung synchronisieren",
        syncRotation: "Rotation synchronisieren",
        syncZoom: "Zoom synchronisieren",
        syncAll: "Alles synchronisieren"
      }
    }
  },
}